<style scoped>
.ShowHeader {
  width: 1100px;
  height: 150px;
  margin: 0 auto;
  padding-top: 40px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.ShowHeader >>> .el-input__inner {
  height: 53px !important;
  border-radius: 10px;
  font-weight: 500;
  font-size: 16px;
}
.changeConter {
  background: #ffffff;
  float: left;
  width: 100%;
  height: 53px;
  border-radius: 10px;
}
.changeConter >>> .el-input__inner {
  border: none !important;
  padding-left: 50px !important;
}
.Guiji {
  padding: 15px 0;
}
.Guiji >>> .el-input__inner {
  height: 53px !important;
}
.GuessWrap {
  width: 1100px;
  margin: 0 auto;
}
</style>
<template>
  <div class="index_wrap" style="height: calc(90%); position: relative">
    <div class="ShowHeader" :class="topType ? 'headerTop' : 'hindDown'">
      <!--查价列表：业务类型选择器-->
      <!--<div v-show="avtive == 0">-->
      <!--<el-select-->
      <!--style="width: 136px; height: 53px"-->
      <!--v-model="Sonindex"-->
      <!--@change="changeselect"-->
      <!--placeholder="请选择"-->
      <!--&gt;-->
      <!--<el-option-->
      <!--v-for="(item, index) in Typelist"-->
      <!--:disabled="item.disabled"-->
      <!--:key="index"-->
      <!--:label="item.name"-->
      <!--:value="index"-->
      <!--&gt;</el-option>-->
      <!--</el-select>-->
      <!--</div>-->
      <!-- 选择器 -->
      <div class="changeConter" style="width: 910px" v-show="avtive == 0">
        <!-- 海运散货 空运 -->
        <div class="HYsouch" v-show="Sonindex == 0 || Sonindex == 2">
          <div style="width: 100%; box-sizing: border-box; float: left">
            <div class="selectWrap" style="width: 50%">
              <el-select
                suffix-icon="el-icon-date"
                style="float: left; width: 100%"
                class="Mostyle"
                @change="changeCk(pollandId)"
                v-model="pollandId"
                filterable
                :placeholder="$t('i18n_Please_choose_original_wareohuse')"
              >
                <template v-if="Sonindex == 0">
                  <el-option
                    v-for="item in LCLWarehouseList"
                    :key="item.id"
                    :label="item.namec"
                    :value="item.id"
                  >
                  </el-option>
                </template>
                <template v-else>
                  <el-option
                    v-for="item in KYWarehouseList"
                    :key="item.id"
                    :label="item.namec"
                    :value="item.id"
                  >
                  </el-option>
                </template>
                <i
                  style="font-size: 28px; margin-top: 5px; margin-left: 10px"
                  slot="prefix"
                  class="el-input__icon el-icon-s-home"
                ></i>
              </el-select>
            </div>
            <div
              style="
                width: 50%;
                padding: 0 1px;
                box-sizing: border-box;
                float: left;
                border-left: 1px solid #eeeeee;
              "
            >
              <div class="select2" style="float: left; width: 100%">
                <span class="selectIcon2" style="top: 12px; font-size: 28px">
                  <i class="el-icon-map-location"></i>
                </span>
                <el-cascader
                  :placeholder="$t('i18n_please_choose_your_destination')"
                  style="width: 100%"
                  @change="changeECk(WarehousItemID)"
                  ref="refshouname"
                  :options="WarehouseList"
                  v-model="WarehousItemID"
                  :props="defaultParams"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.namec }}</span>
                    <span v-if="!node.isLeaf"></span>
                  </template>
                </el-cascader>
              </div>
            </div>
          </div>
        </div>
        <!-- 海运散货 空运END -->
        <!-- FBA -->
        <div class="FBAsouch" v-show="Sonindex == 3">
          <div style="width: 100%; box-sizing: border-box; float: left">
            <div
              class="selectWrap"
              style="width: 50%; float: left; position: relative"
            >
              <span class="selectIcon2" style="top: 12px; font-size: 28px">
                <i class="el-icon-s-home"></i>
              </span>
              <el-cascader
                style="width: 100%"
                :placeholder="$t('i18n_Please_choose_original_wareohuse')"
                v-model="thatALLcklist"
                :key="cascaderKey"
                :options="FBAfromCk"
                :props="FBAdataprops"
                ref="changefromFABck"
                @change="changefromFABck(thatALLcklist)"
              >
                <i
                  style="font-size: 28px; margin-top: 5px; margin-left: 10px"
                  slot="prefix"
                  class="el-input__icon el-icon-s-home"
                ></i>
              </el-cascader>
            </div>
            <div
              style="
                width: 50%;
                padding: 0 1px;
                box-sizing: border-box;
                float: left;
                border-left: 1px solid #eeeeee;
              "
            >
              <div class="select2" style="float: left; width: 100%">
                <span class="selectIcon2" style="top: 12px; font-size: 28px">
                  <i class="el-icon-map-location"></i>
                </span>
                <el-cascader
                  :placeholder="$t('i18n_please_choose_your_destination')"
                  style="width: 100%"
                  ref="changetoFABck"
                  v-model="thatFBAcklist"
                  :options="FBAtoCk"
                  :props="toFBAdataprops"
                  @change="changetoFABck(thatFBAcklist)"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.namec }}</span>
                    <span v-if="!node.isLeaf"></span>
                  </template>
                </el-cascader>
              </div>
            </div>
          </div>
        </div>
        <!-- FBA--END -->

        <!-- 整柜 -->
        <div class="FBAsouch" v-show="Sonindex == 1">
          <div style="width: 100%; box-sizing: border-box; float: left">
            <div class="selectWrap" style="width: 50%; float: left">
              <el-select
                @change="onFclSelectChange"
                style="width: 100%"
                v-model="fclRequestParams.pol"
                :placeholder="$t('i18n_please_choose')"
              >
                <el-option
                  v-for="(item, index) in startPorts"
                  :key="index"
                  :label="item.enName + ' ' + item.cnName"
                  :value="item.code"
                >
                  <div style="display: flex; justify-content: space-between">
                    <span>{{ `${item.enName} ${item.cnName}` }}</span>
                    <span>{{ `${item.country}` }} {{ item.city || "" }}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
            <div
              style="
                width: 50%;
                padding: 0 1px;
                box-sizing: border-box;
                float: left;
                border-left: 1px solid #eeeeee;
              "
            >
              <div class="select2" style="float: left; width: 100%">
                <span class="selectIcon2" style="top: 12px; font-size: 28px">
                  <i class="el-icon-map-location"></i>
                </span>
                <el-select
                  @change="onFclSelectChange"
                  style="width: 100%"
                  v-model="fclRequestParams.pod"
                  :placeholder="$t('i18n_please_choose')"
                >
                  <el-option
                    v-for="(item, index) in endPorts"
                    :key="index"
                    :label="item.enName + ' ' + item.cnName"
                    :value="item.code"
                  >
                    <div style="display: flex; justify-content: space-between">
                      <span>{{ `${item.enName} ${item.cnName}` }}</span>
                      <span>{{ `${item.country}` }} {{ item.city || "" }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <!-- 整柜--END -->
      </div>
      <!-- 轨迹搜索 -->
      <div
        class="changeConter searchWrap"
        style="width: 930px"
        v-show="avtive == 1"
      >
        <el-input
          style="width: 100%; height: 53px"
          v-model="inos"
          :placeholder="$t('i18n_Please_enter_the_order_number_to_inquire')"
        ></el-input>
      </div>
      <!-- 轨迹搜索END -->
      <!-- 查询报价 -->
      <div v-show="avtive == 0">
        <el-button
          style="
            width: 160px;
            background: #fff157;
            border: 1px solid #fff157;
            color: #5ab53c;
            height: 53px;
            font-size: 18px;
            font-weight: 500;
            border-radius: 10px;
          "
          @click="getFiledata"
          type="primary"
          icon="el-icon-search"
          >{{ $t("i18n_Inquiry") }}</el-button
        >
      </div>
      <!-- 查询轨迹 -->
      <div v-show="avtive == 1">
        <el-button
          :loading="trackLoading"
          style="
            width: 160px;
            background: #fff157;
            border: 1px solid #fff157;
            color: #5ab53c;
            height: 53px;
            font-size: 18px;
            font-weight: 500;
            border-radius: 10px;
          "
          @click="Searchgj"
          type="primary"
          icon="el-icon-search"
          >{{ $t("i18n_Inquiry") }}</el-button
        >
      </div>
    </div>
    <p
      :class="topType ? 'hindDown' : 'headerTop'"
      style="
        float: left;
        text-align: center;
        width: 100%;
        font-size: 48px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #ffffff;
        text-shadow: 0px 0px 39px rgba(31, 24, 78, 0.15);
        margin-top: 5%;
      "
    >
      {{ $t("i18n_Index_title") }}
    </p>
    <p
      :class="topType ? 'hindDown' : 'headerTop'"
      style="
        float: left;
        text-align: center;
        width: 100%;
        font-size: 32px;
        font-family: PingFang SC;
        letter-spacing: 4px;
        color: #ffffff;
        text-shadow: 0px 0px 39px rgba(31, 24, 78, 0.15);
        margin-top: 10px;">{{ $t('i18n_Index_title_l') }}</p>
    <!-- 物流产品 选择器 -->
    <div class="nav_count">
      <div style="">
        <div :class="topType ? 'hindDown' : 'showTop '">
          <div class="navlist">
            <ul>
              <li
                :class="avtive == index ? 'navStyle' : ''"
                class="oldnavcalss"
                @click="changeNav(index)"
                v-for="(item, index) in navLIst"
                :key="index"
              >
                <!-- <span
                  ><img
                    :style="{ width: item.width, height: item.height }"
                    style="
                      width: 100%;
                      height: 100%;
                      display: block;
                      margin-right: 6px;
                    "
                    :src="item.url"
                    alt=""
                /></span> -->
                <span style="opacity: 1">{{ $t(item.name) }}</span>
              </li>
            </ul>
          </div>
          <!-- 物流产品 选项卡 -->
          <div class="count_text">
            <div class="navCountshow" v-show="avtive == 0">
              <!--首页物流产品：业务类型选择器-->
              <div style="width: 100%; float: left">
                <div
                  class="typeNAv"
                  style="margin-bottom: 35px; width: 100%; float: left"
                >
                  <div
                    class="navItem"
                    :class="Sonindex == item.index ? 'activesonty' : ''"
                    v-for="item in Typelist"
                    :key="item.index"
                    @click="changesonNav(item.index)"
                  >
                    <div style="display: flex; align-items: center">
                      <img
                        style="margin-right: 5px"
                        :src="Sonindex == item.index ? item.url2 : item.url1"
                        alt=""
                      />
                      {{ $t(item.name) }}
                      <span
                        class="navson"
                        :class="Sonindex == item.index ? 'activesonty2' : ''"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 海运散货 -->
              <div v-show="Sonindex == 0 || Sonindex == 2" class="SHtext">
                <!-- <div v-show="Sonindex == 1" class="SHtext"> -->
                <div class="wrap_s" style="width: 100%; margin-bottom: 16px">
                  <el-row :gutter="20">
                    <el-col :span="10">
                      <div
                        style="
                          width: 100%;
                          padding: 0 1px;
                          box-sizing: border-box;
                          float: left;
                        "
                      >
                        <div class="selectWrap">
                          <span class="selectIcon">
                            <i class="el-icon-s-home"></i>
                          </span>
                          <el-select
                            style="float: left; width: 100%"
                            class="Mostyle"
                            @change="changeCk(pollandId)"
                            v-model="pollandId"
                            filterable
                            :placeholder="
                              $t('i18n_Please_choose_original_wareohuse')
                            "
                          >
                            <template v-if="Sonindex == 0">
                              <el-option
                                v-for="item in LCLWarehouseList"
                                :key="item.id"
                                :label="item.namec"
                                :value="item.id"
                              >
                              </el-option>
                            </template>
                            <template v-else>
                              <el-option
                                v-for="item in KYWarehouseList"
                                :key="item.id"
                                :label="item.namec"
                                :value="item.id"
                              >
                              </el-option>
                            </template>
                          </el-select>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="10">
                      <div
                        style="
                          width: 100%;
                          padding: 0 1px;
                          box-sizing: border-box;
                          float: left;
                        "
                      >
                        <div class="select2" style="float: left; width: 100%">
                          <span class="selectIcon2">
                            <i class="el-icon-map-location"></i>
                          </span>

                          <el-cascader
                            :placeholder="
                              $t('i18n_please_choose_your_destination')
                            "
                            style="width: 100%"
                            @change="changeECk(WarehousItemID)"
                            ref="refshouname"
                            :options="WarehouseList"
                            v-model="WarehousItemID"
                            :props="defaultParams"
                            @click.native="getWarehouse"
                          >
                            <template slot-scope="{ node, data }">
                              <span>{{ data.namec }}</span>
                              <span v-if="!node.isLeaf"></span>
                            </template>
                          </el-cascader>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <el-button
                        style="width: 160px; border-radius: 10px"
                        @click="getFiledata()"
                        type="primary"
                        icon="el-icon-search"
                        >{{ $t("i18n_Inquiry") }}</el-button
                      >
                    </el-col>
                  </el-row>
                </div>
                <!-- <div class="wrap_s" style="width: 100%; margin-bottom: 16px">
                  <el-row :gutter="20">
                    <el-col :span="10">
                      <el-input
                        style=""
                        prefix-icon="el-icon-box"
                        v-model="cbm"
                        placeholder="请输入货物体积"
                        @keyup.native="keyupEvent($event, cbm)"
                      >
                        <i slot="suffix" class="el-input__icon">CBM</i>
                      </el-input>
                    </el-col>
                    <el-col :span="10">
                      <el-input
                        style=""
                        prefix-icon="el-icon-odometer"
                        v-model="weight"
                        placeholder="请输入货物重量"
                        @keyup.native="keyupEvent($event, weight)"
                      >
                        <i slot="suffix" class="el-input__icon">KG</i>
                      </el-input>
                    </el-col>
                    <el-col :span="4"
                      ><el-button
                        style="width: 160px; border-radius: 10px"
                        @click="getFiledata()"
                        type="primary"
                        icon="el-icon-search"
                        >{{$t('i18n_Inquiry')}}</el-button
                      ></el-col
                    >
                  </el-row>
                </div> -->
              </div>
              <!-- 海运散货end -->

              <!-- fab头程 -->
              <div class="FBAtext" v-show="Sonindex == 3">
                <div class="wrap_s" style="width: 100%; margin-bottom: 16px">
                  <el-row :gutter="20">
                    <el-col :span="10">
                      <div
                        style="
                          width: 100%;
                          padding: 0 1px;
                          box-sizing: border-box;
                          float: left;
                        "
                      >
                        <div class="selectWrap">
                          <span class="selectIcon">
                            <i class="el-icon-s-home"></i>
                          </span>
                          <el-cascader
                            style="width: 100%"
                            :placeholder="
                              $t('i18n_Please_choose_original_wareohuse')
                            "
                            v-model="thatALLcklist"
                            :options="FBAfromCk"
                            :props="FBAdataprops"
                            ref="changefromFABck"
                            @change="changefromFABck(thatALLcklist)"
                          ></el-cascader>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="10">
                      <div
                        style="
                          border-radius: 4px;
                          width: 100%;
                          padding: 0 1px;
                          box-sizing: border-box;
                          float: left;
                        "
                      >
                        <div class="select2" style="float: left; width: 100%">
                          <span class="selectIcon2">
                            <i class="el-icon-map-location"></i>
                          </span>

                          <el-cascader
                            :placeholder="
                              $t('i18n_please_choose_your_destination')
                            "
                            style="width: 100%"
                            ref="changetoFABck"
                            v-model="thatFBAcklist"
                            :options="FBAtoCk"
                            :props="toFBAdataprops"
                            @change="changetoFABck(thatFBAcklist)"
                          >
                            <template slot-scope="{ node, data }">
                              <span>{{ data.namec }}</span>
                              <span v-if="!node.isLeaf"></span>
                            </template>
                          </el-cascader>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="4"
                      ><el-button
                        style="width: 160px; border-radius: 10px"
                        @click="getFiledata()"
                        type="primary"
                        icon="el-icon-search"
                        >{{ $t("i18n_Inquiry") }}</el-button
                      ></el-col
                    >
                  </el-row>
                </div>
              </div>
              <!-- fab头程end -->

              <!-- 整柜 -->
              <div class="FBAtext" v-show="Sonindex == 1">
                <div class="wrap_s" style="width: 100%; margin-bottom: 16px">
                  <el-row :gutter="20">
                    <el-col :span="10">
                      <div
                        style="
                          width: 100%;
                          padding: 0 1px;
                          box-sizing: border-box;
                          float: left;
                        "
                      >
                        <div class="selectWrap">
                          <span class="selectIcon">
                            <i class="el-icon-s-home"></i>
                          </span>
                          <el-select
                            style="width: 100%"
                            v-model="fclRequestParams.pol"
                            :placeholder="$t('i18n_please_choose')"
                          >
                            <el-option
                              v-for="(item, index) in startPorts"
                              :key="index"
                              :label="item.enName + ' ' + item.cnName"
                              :value="item.code"
                            >
                              <div
                                style="
                                  display: flex;
                                  justify-content: space-between;
                                "
                              >
                                <span>{{
                                  `${item.enName} ${item.cnName}`
                                }}</span>
                                <span
                                  >{{ `${item.country}` }}
                                  {{ item.city || "" }}</span
                                >
                              </div>
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="10">
                      <div
                        style="
                          border-radius: 4px;
                          width: 100%;
                          padding: 0 1px;
                          box-sizing: border-box;
                          float: left;
                        "
                      >
                        <div class="select2" style="float: left; width: 100%">
                          <span class="selectIcon2">
                            <i class="el-icon-map-location"></i>
                          </span>

                          <el-select
                            @change="fclChange()"
                            style="width: 100%"
                            v-model="fclRequestParams.pod"
                            :placeholder="$t('i18n_please_choose')"
                          >
                            <el-option
                              v-for="(item, index) in endPorts"
                              :key="index"
                              :label="item.enName + ' ' + item.cnName"
                              :value="item.code"
                            >
                              <div
                                style="
                                  display: flex;
                                  justify-content: space-between;
                                "
                              >
                                <span>{{
                                  `${item.enName} ${item.cnName}`
                                }}</span>
                                <span
                                  >{{ `${item.country}` }}
                                  {{ item.city || "" }}</span
                                >
                              </div>
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="4"
                      ><el-button
                        style="width: 160px; border-radius: 10px"
                        @click="getFiledata()"
                        type="primary"
                        icon="el-icon-search"
                        >{{ $t("i18n_Inquiry") }}</el-button
                      ></el-col
                    >
                  </el-row>
                </div>
              </div>
              <!-- 整柜 end -->
            </div>
            <!-- 轨迹搜索框 -->
            <div class="Guiji" v-show="avtive == 1">
              <el-row :gutter="20">
                <el-col :span="20">
                  <el-input
                    style="width: 100%; height: 53px"
                    v-model="inos"
                    :placeholder="
                      $t('i18n_Please_enter_the_order_number_to_inquire')
                    "
                  ></el-input>
                </el-col>
                <el-col :span="4">
                  <el-button
                    :loading="trackLoading"
                    class="el-icon-search"
                    style="
                      width: 100%;
                      height: 53px;
                      font-size: 18px;
                      border-radius: 10px;
                    "
                    type="primary"
                    @click="Searchgj()"
                    >{{ $t("i18n_Inquiry") }}</el-button
                  >
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- 选项卡end -->
        </div>
      </div>
    </div>

    <div
      class="show_count"
      :class="topType ? 'showbgColor showDown' : 'showTop'"
    >
      <!-- 查询报价show_count -->
      <div style="width: 100%; height: 100%" v-show="avtive == 0">
        <!-- <div class="huowuData"> -->
        <!-- jack div start -->
        <div class="huowuData" v-show="lableData.length">
          <div
            class="card_wrap"
            v-show="Sonindex == 1 || Sonindex == 3"
            style="padding: 30px"
            v-if="false"
          >
            <div>
              <span style="font-weight: 600"
                >如需要“门到门”相关服务，请勾选以下选项：</span
              >
              <!-- 第一个 start -->
              <div style="margin-top: 20px">
                <div
                  style="
                    border-bottom: 1px solid #eee;
                    padding-bottom: 30px;
                    margin-bottom: 30px;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <el-checkbox v-model="checked1"></el-checkbox>
                    <span
                      style="
                        margin-left: 10px;
                        font-size: 18px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #333333;
                      "
                    >
                      起运地 上门提货</span
                    >
                  </div>

                  <div
                    v-show="checked1"
                    class="animate__animated animate__fadeIn"
                    style="display: flex; align-items: center; margin-top: 20px"
                  >
                    <span>{{ $t("i18n_pickup_location") }}</span>
                    <div
                      @click="showDialogOfMine()"
                      style="
                        margin-left: 10px;
                        color: #999;
                        border: 1px solid #eee;
                        padding: 8px;
                        width: 30%;
                        cursor: pointer;
                        border-radius: 5px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                      "
                    >
                      <span>{{
                        countLIst_T.parvince
                          ? countLIst_T.parvince +
                            " " +
                            countLIst_T.city +
                            " " +
                            countLIst_T.area +
                            " " +
                            countLIst_T.address
                          : "请选择提货地点"
                      }}</span>

                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </div>
                <!-- 第一个 end -->
                <!-- 第2个 start -->
                <div
                  style="margin-top: 20px"
                  v-show="Sonindex == 1 || Sonindex == 3"
                >
                  <div style="margin-bottom: 0px">
                    <div style="display: flex; align-items: center">
                      <el-checkbox v-model="checked2"></el-checkbox>
                      <span
                        style="
                          margin-left: 10px;
                          font-size: 18px;
                          font-family: PingFang SC;
                          font-weight: 500;
                          color: #333333;
                        "
                      >
                        目的地 送货上门</span
                      >
                    </div>

                    <div
                      v-show="checked2"
                      class="animate__animated animate__fadeIn"
                      style="
                        display: flex;
                        align-items: center;
                        margin-top: 20px;
                      "
                    >
                      <span>派送地点</span>
                      <div
                        @click="showDialogOfMine('PS')"
                        style="
                          margin-left: 10px;
                          color: #999;
                          border: 1px solid #eee;
                          padding: 8px;
                          width: 30%;
                          cursor: pointer;
                          border-radius: 5px;
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                        "
                      >
                        <span
                          >{{
                            countLIst_C.country
                              ? countLIst_C.country +
                                " " +
                                countLIst_C.city +
                                " " +
                                countLIst_C.area +
                                " " +
                                countLIst_C.address
                              : "请选择派送地点"
                          }}
                        </span>

                        <i class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 第2个 end -->
                <div
                  v-if="checked1 || checked2"
                  class="redBtn"
                  @click="goQuery()"
                >
                  进一步查价
                </div>
              </div>
            </div>
          </div>

          <div
            v-show="isSelected"
            class="card_wrap"
            :class="
              topType ? 'animate__animated animate__lightSpeedInRight' : ''
            "
            v-for="(item, index) in lableData"
            :key="index"
          >
            <div class="wrap_l" style="float: left; width: 80%">
              <div class="count_Top" style="display: flex; align-items: center">
                <div style="float: left" class="LR_center">
                  <div
                    style="
                      font-size: 28px;
                      font-family: PingFang SC;
                      font-weight: bold;
                      color: #343434;
                    "
                  >
                    {{ item.goodstype }}{{ item.transportTypeName }}
                    <!-- fba显示内容 -->
                    {{ item.productName ? item.productName : "" }}
                    <!-- fba\end-->
                  </div>
                  <div
                    style="
                      min-width: 100px;
                      min-height: 30px;
                      background: #ffffff;
                      border: 1px solid #5ab53c;
                      border-radius: 17px;
                      text-align: center;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      line-height: 1;
                      margin-top: 4px;
                      margin-left: 30px;
                      color: #5ab53c;
                      cursor: pointer;
                    "
                    @click="showText(item)"
                  >
                    {{ $t("i18n_Shipping_Instructions") }}
                  </div>
                  <!-- <el-button
                      style="color: #604aff"
                      type="primary" plain round
                      size="small"
                      @click="showText(item)"
                      >发货说明</el-button
                    > -->
                </div>
                <div
                  style="
                    float: left;
                    margin-left: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div class="fontTyle" style="float: left">
                    {{ cangkuShow.namec }}
                  </div>
                  <div
                    style="
                      width: 155px;
                      float: left;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <span
                      style="color: red"
                      v-if="
                        item.prescriptionAdditionalRemark !== null &&
                        Sonindex === 3
                      "
                      >{{ item.prescriptionAdditionalRemark
                      }}{{ item.prescriptionbegin }}-{{ item.prescriptionend
                      }}{{ $t("i18n_natural_days") }}</span
                    >
                    <span
                      style="color: red; max-width: 120px; padding-bottom: 5px"
                      v-if="item.productId == '85131913000'"
                    >
                      {{ $t("i18n_minimum_20kg") }}
                    </span>
                    <span
                      style="color: red; max-width: 120px; padding-bottom: 5px"
                      v-if="item.productId == '85332194000'"
                    >
                      {{ $t("i18n_minimum_150kg") }}
                    </span>
                    <span
                      :style="{
                        color:
                          item.productId == '85131913000'
                            ? 'red'
                            : item.productId == '85332194000'
                            ? 'red'
                            : '#9a9a9a'
                      }"
                      v-if="item.prescriptionAdditionalRemark == null"
                      >{{ item.prescriptionbegin }}-{{ item.prescriptionend
                      }}{{ $t("i18n_natural_days") }}</span
                    >
                    <span class="jiantou"></span>
                    <span
                      style="color: red; max-width: 155px; padding-top: 5px"
                      v-if="item.productId == '85131913000'"
                    >
                      {{ $t("i18n_non_electrified_flight") }}
                    </span>
                    <span
                      style="color: red; max-width: 155px; padding-top: 5px"
                      v-if="item.productId == '85131913000'"
                    >
                      {{ $t("i18n_domestic_flights") }}
                    </span>
                    <span
                      style="color: red; max-width: 155px; padding-top: 5px"
                      v-if="item.productId == '85332194000'"
                    >
                      {{ $t("i18n_non_electrified_flight") }}
                    </span>
                    <span
                      style="color: red; max-width: 155px; padding-top: 5px"
                      v-if="item.productId == '85332194000'"
                    >
                      {{ $t("i18n_domestic_flights") }}
                    </span>
                    <slot name="reference"></slot>
                    <el-popover
                      v-if="
                        item.prescriptionAdditionalRemark !== null &&
                        Sonindex === 3
                      "
                      placement="bottom"
                      title=""
                      width="200"
                      trigger="hover"
                    >
                      <span style="color: red">{{
                        item.additionalRemark
                      }}</span>
                      <div
                        style="
                          min-width: 100px;
                          min-height: 30px;
                          background: #ffffff;
                          text-align: center;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          line-height: 1;
                          margin-top: 4px;
                          color: red;
                          cursor: pointer;
                        "
                        slot="reference"
                      >
                        规则说明
                      </div>
                    </el-popover>
                  </div>
                  <div class="fontTyle" style="float: left">
                    <span>{{ welickShow.namec }}</span>
                  </div>
                </div>
              </div>
              <div class="textCount" style="margin-top: 20px">
                <el-row :gutter="20">
                  <el-col :span="5" v-if="item.deliveryPriceInfo">
                    <div class="nav_count">
                      <span class="PSicon"></span> 派送费：{{
                        item.deliveryPriceInfo
                      }}
                    </div>
                  </el-col>
                  <el-col :span="8" v-if="item.pickUpPriceDTO">
                    <div class="nav_count">
                      <span class="Thicon"></span>
                      {{ $t("i18n_pickup_fee") }}：{{
                        item.pickUpPriceDTO.priceInfo
                      }}（{{ item.pickUpPriceDTO.minKilometer }}-{{
                        item.pickUpPriceDTO.maxKilometer
                      }}KM）
                    </div>
                  </el-col>
                  <el-col :span="10">
                    <div>
                      <span class="Djicon"></span>
                      <span>{{ $t("i18n_shipping_cost") }}</span>
                      <span
                        style="
                          color: #fe1818;
                          font-weight: bold;
                          text-decoration: underline;
                        "
                        >{{
                          $t("i18n_from_x_currency", {
                            currency: item.currency,
                            price: item.priceinfo
                          })
                        }}</span
                      >
                      <span class="vipIcon">{{ item.pricedescription }}</span>
                    </div>
                  </el-col>
                  <el-col :span="6" v-if="item.deliverPrice">
                    <div>
                      <span class="Djicon"></span>
                      <span>派送费</span>
                      <span
                        style="
                          color: #fe1818;
                          font-weight: bold;
                          text-decoration: underline;
                        "
                        >{{ item.deliverPriceCurrency
                        }}{{ item.deliverPrice }}</span
                      >
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="count_Bom">
                <div class="Bom_style" v-if="item.label1">
                  {{ item.label1 }}
                </div>
                <div class="Bom_style" v-if="item.label2">
                  {{ item.label2 }}
                </div>
                <div class="Bom_style" v-if="item.label3">
                  {{ item.label3 }}
                </div>
              </div>
            </div>
            <div
              class="wrap_r"
              style="
                width: 20%;
                float: left;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-top: 30px;
              "
            >
              <div
                class="Gotobtn"
                :class="
                  activeIndex == index
                    ? 'animate__animated animate__rubberBand'
                    : ''
                "
                @click="handleClick(item)"
                @mouseenter="outStyle(index)"
                @mouseout="activeIndex = null"
              >
                {{ $t("i18n_Go_to_Order") }}
              </div>
              <!-- 非FBA的价格详情 -->
              <el-popover
                v-if="item.stepwiseDTOS && Sonindex != 3"
                placement="bottom"
                width="430"
                trigger="click"
              >
                <div
                  class="LR_center"
                  style="border-bottom: 1px dashed #dcdcdc; padding: 12px 0"
                  v-for="(_item, _index) in item.stepwiseDTOS"
                  :key="_index"
                >
                  <div>
                    <span style="color: #9a9a9a"
                      >{{ _item.stepwise }}({{ item.stepwiseUnit }})</span
                    >
                  </div>
                  <div>
                    <span style="font-size: 13px; font-weight: bold"
                      >￥{{ _item.priceInfo }}</span
                    >
                    <span class="vipIcon">{{ item.pricedescription }}</span>
                  </div>
                </div>
                <el-button type="text" slot="reference">{{
                  $t("i18n_Price_Details")
                }}</el-button>
              </el-popover>
              <!-- FBA的价格详情 -->
              <el-popover
                v-if="item.stepwiseDTOS && Sonindex == 3"
                placement="bottom"
                width="530"
                trigger="click"
              >
                <div class="FBAtable" style="width: 100%">
                  <div
                    v-for="(_item, _index) in item.stepwiseDTOS"
                    :key="_index"
                    style="
                      border: solid 1px #eee;
                      border-bottom: solid 1px #fff;
                      display: flex;
                      justify-content: space-between;
                    "
                  >
                    <div
                      style="padding: 8px; display: flex; align-items: center"
                    >
                      <span style="width: 130px; text-align: center">{{
                        _item.goodTypeCodes
                      }}</span>
                    </div>
                    <div
                      style="
                        border-left: 1px solid #eee;
                        width: 100%;
                        text-align: center;
                      "
                    >
                      <div
                        v-for="(res, _index) in _item.stepwiseDTOS"
                        :key="_index"
                      >
                        <div style="padding: 8px">
                          <div class="LR_center">
                            <span style="margin: 5px">{{ res.stepwise }}</span>
                            <span style="color: #333333; font-weight: bold"
                              >{{ _item.currency }}{{ res.priceInfo }}</span
                            >
                          </div>
                        </div>

                        <!-- 判断里面的borde-bottom  -->
                        <div
                          v-if="!(_index == _item.stepwiseDTOS.length - 1)"
                          style="height: 1px; background: #eee; width: 100%"
                        ></div>
                        <!-- 判断里面的borde-bottom  -->
                      </div>
                    </div>
                  </div>
                  <div style="height: 1px; background: #eee; width: 100%"></div>
                </div>
                <el-button type="text" slot="reference">{{
                  $t("i18n_Price_Details")
                }}</el-button>
              </el-popover>
            </div>
          </div>
        </div>

        <!-- 整柜查价 查价灰色区域 整柜 -->
        <div class="huowuData" v-show="fclPriceList.length">
          <el-container style="width: 1150px; padding: 0 30px">
            <el-aside class="aside" style="width: 260px">
              <div style="display: flex">
                <el-checkbox style="width: 100px; margin: 0"
                  ><span style="font-weight: bold">拖车报关</span></el-checkbox
                >
                <el-checkbox style="width: 100px; margin: 0"
                  ><span style="font-weight: bold">拖柜清关</span></el-checkbox
                >
              </div>

              <p style="font-weight: 600; margin: 10px 0">船公司</p>
              <div>
                <el-checkbox-group
                  @change="onCheckBoxChange($event, 'shipCompanies')"
                  v-model="fclRequestParams.carriers"
                >
                  <el-checkbox
                    style="width: 100px; margin: 2px 0"
                    v-for="(item, index) in shipCompanies"
                    :key="index"
                    :label="item.code"
                    :disabled="item.disabled"
                    ><span style="font-weight: bold">{{
                      item.abbr
                    }}</span></el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <p style="font-weight: 600; margin: 10px 0">班期</p>
              <div>
                <el-checkbox-group
                  @change="onCheckBoxChange($event, 'weekList')"
                  v-model="fclRequestParams.days"
                >
                  <el-checkbox
                    style="width: 100px; margin: 2px 0"
                    v-for="(item, index) in weekList"
                    :key="index"
                    :label="item.value"
                    ><span style="font-weight: bold">{{
                      item.label
                    }}</span></el-checkbox
                  >
                </el-checkbox-group>
              </div>

              <p style="font-weight: 600; margin: 10px 0">预计开船</p>
              <div>
                <el-checkbox-group
                  @change="onCheckBoxChange($event, 'dayList')"
                  v-model="fclRequestParams.etdWeeks"
                >
                  <el-checkbox
                    style="width: 100px; margin: 2px 0"
                    v-for="(item, index) in dayList"
                    :key="index"
                    :label="item.value"
                    ><span style="font-weight: bold">{{
                      item.label
                    }}</span></el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-aside>
            <el-main
              class="myhover"
              style="width: 100%; padding: 0; overflow: visible"
            >
              <div
                class="priceCard"
                v-show="isSelected"
                :class="
                  topType ? 'animate__animated animate__lightSpeedInRight' : ''
                "
                v-for="(item, index) in fclPriceList"
                :key="index"
              >
                <div class="cardBody">
                  <!-- 船公司 LOGO-->
                  <el-image
                    style="width: 30px; height: 30px; border-radius: 50%"
                    fit="none"
                    url=""
                  ></el-image>
                  <!-- 船公司 -->
                  <div class="fontStyle">{{ item.carrier || "" }}</div>
                  <!-- 开船日 -->
                  <div class="fontStyle">{{ item.etd.substring(5) || "" }}</div>
                  <!-- 直达 -->
                  <div class="timeArea">
                    <span style="">{{ `${item.tt} 天 ` || "" }} 直达</span>
                    <span style="color: #999"
                      >航线 {{ item.shipline || "" }}</span
                    >
                  </div>
                  <!-- 预计到达日 -->
                  <div class="fontStyle">{{ item.eta.substring(5) || "" }}</div>
                  <!-- 截关 -->
                  <div class="fontStyle">
                    {{ item.cls.substring(5) || "2" }}
                  </div>
                  <!-- 免柜 -->
                  <div class="fontStyle">
                    {{ item.returnContainerTerm || "" }}天
                  </div>

                  <div v-if="item.showPrice" class="fontStyle" style="">
                    <el-popover trigger="hover" placement="bottom-end">
                      <div class="MyscrollbarS">
                        <div
                          v-if="
                            item.cntypeOfferPriceDTOS &&
                            item.cntypeOfferPriceDTOS.length
                          "
                        >
                          <div
                            v-for="(
                              innerItem, InnerItemIndex
                            ) in item.cntypeOfferPriceDTOS"
                            :key="InnerItemIndex"
                            style="
                              border-bottom: 1px dashed #999;
                              padding: 8px;
                              display: flex;
                              justify-content: space-between;
                            "
                          >
                            <span>{{ innerItem.cntypeCode || "暂无" }}</span>
                            <span>
                              {{ innerItem.currency || "" }}
                              <span>{{ innerItem.price || "" }}</span>
                            </span>
                          </div>
                          <!-- 占位  -->
                          <div style="height: 20px"></div>
                        </div>
                        <div style="text-align: center" v-else>暂无内容</div>
                      </div>
                      <div slot="reference">
                        <span
                          class="fontStyle"
                          style="
                            color: red;
                            border-bottom: 1px dashed #999;
                            font-size: 17px;
                          "
                          >$1150</span
                        >
                        <span style="font-size: 12px; height: 0">起</span>
                      </div>
                    </el-popover>
                  </div>
                  <div v-if="item.showPrice" class="fontStyle" style="">
                    <el-popover trigger="hover" placement="bottom-end">
                      <div
                        class="MyscrollbarS"
                        style="height: 500px; width: 400px"
                      >
                        <div
                          v-if="
                            item.additionalChargeDTOList &&
                            item.additionalChargeDTOList.length
                          "
                        >
                          <div
                            v-for="(
                              innerItem, InnerItemIndex
                            ) in item.additionalChargeDTOList"
                            :key="InnerItemIndex"
                            style="
                              border: solid 1px #eee;
                              border-bottom: solid 1px #fff;
                              display: flex;
                              justify-content: space-between;
                            "
                          >
                            <!-- FAF(燃油附加费) -->
                            <div
                              style="
                                padding: 8px;
                                display: flex;
                                align-items: center;
                              "
                            >
                              <span style="width: 130px; text-align: center">{{
                                innerItem.feeName || "暂无"
                              }}</span>
                            </div>
                            <!-- FAF(燃油附加费)end -->
                            <!--  暂无 CNY13.00/柜
                                    暂无 CNY13.00/柜
                                    暂无 CNY13.00/柜 -->
                            <div
                              style="
                                border-left: 1px solid #eee;
                                width: 100%;
                                text-align: center;
                              "
                            >
                              <div
                                v-for="(
                                  SecinnerItem, SecInnerItemIndex
                                ) in innerItem.cntypeChargeDTOList"
                                :key="SecInnerItemIndex"
                              >
                                <div style="padding: 8px">
                                  <div>
                                    <span style="margin: 5px">
                                      {{
                                        SecinnerItem.cntypeCode || "暂无"
                                      }}</span
                                    >
                                    <span>{{
                                      SecinnerItem.priceDesc || ""
                                    }}</span>
                                  </div>
                                </div>

                                <!-- 判断里面的borde-bottom  -->
                                <div
                                  v-if="
                                    !(
                                      SecInnerItemIndex ==
                                      innerItem.cntypeChargeDTOList.length - 1
                                    )
                                  "
                                  style="
                                    height: 1px;
                                    background: #eee;
                                    width: 100%;
                                  "
                                ></div>
                                <!-- 判断里面的borde-bottom  -->
                              </div>
                            </div>
                            <!--  暂无 CNY13.00/柜
                                    暂无 CNY13.00/柜
                                    暂无 CNY13.00/柜 end-->
                          </div>

                          <div
                            style="height: 1px; background: #eee; width: 100%"
                          ></div>
                          <!-- 占位  -->
                          <div style="height: 20px"></div>
                        </div>
                        <div style="text-align: center" v-else>暂无内容</div>
                      </div>
                      <div slot="reference">
                        <span
                          class="fontStyle"
                          style="
                            color: red;
                            border-bottom: 1px dashed #999;
                            font-size: 17px;
                          "
                          >$1150</span
                        >
                        <span style="font-size: 12px; height: 0">起</span>
                      </div>
                    </el-popover>
                  </div>

                  <div v-if="!item.showPrice" class="fontStyle">登录后显示</div>
                  <div v-if="!item.showPrice" class="fontStyle">登录后显示</div>
                  <el-button type="primary" size="mini">去订舱</el-button>
                </div>
              </div>
            </el-main>
          </el-container>
        </div>
        <!-- 查价灰色区域 整柜 end-->
      </div>
      <!-- 查询报价show_count END-->
      <!-- 轨迹搜索结果 -->
      <div class="GuessWrap OrderDetails" v-show="avtive == 1">
        <el-alert
          :closable="false"
          v-if="activities.length == 0 && topType && !trackTableData.length"
          :title="$t('i18n_no_tracking_status_yet')"
          type="info"
          :description="$t('i18n_no_track')"
          show-icon
        >
        </el-alert>
        <div v-if="activities.length != 0">
          <!-- 二维数组轨迹 -->
          <el-collapse v-if="activities[0].fbxBoxTrailDTOList" class="track-collapse">
            <el-collapse-item v-for="(item, index) in activities" :key="index">
              <template slot="title">
                <div class="LR_center" style="width: 100%">
                  <div style="flex: 1; min-width: 0; display: flex">
                    <span
                      style="flex-shrink: 0; padding-left: 15px; padding-right: 15px"
                      >{{ item.commonNos }}</span
                    >
                    <div style="min-width: 0">
                      <span style="font-weight: bold">{{ item.name }}</span>
                      <span style="padding-left: 15px; font-weight: bold">{{
                        item.namee
                      }}</span>
                      <span style="padding-left: 15px; color: #999">{{
                        item.occurrenceDate
                      }}</span>
                      <span style="padding-left: 5px; color: #999">{{
                        item.occurrenceTime
                      }}</span>
                    </div>
                  </div>
                  <div
                    style="
                      flex-shrink: 0;
                      white-space: nowrap;
                      margin-left: 10px;
                      color: #67c23a;
                    "
                  >
                    {{ $t("i18n_more_tracking_status") }}
                  </div>
                </div>
              </template>
              <el-timeline style="padding: 0 30px">
                <el-timeline-item
                  type="primary"
                  v-for="(activity, _index) in item.fbxBoxTrailDTOList"
                  :color="activity.color"
                  :key="_index"
                >
                  <div style="width: 100%; float: left; margin-bottom: 5px">
                    {{ activity.occurrenceDate
                    }}<span style="margin-left: 5px">{{
                      activity.occurrenceTime
                    }}</span>
                  </div>
                  <div style="color: #999; font-size: 11px; display: block">
                    <span>{{ activity.name }}</span>
                    <span style="margin-left: 10px" v-if="activity.desc"
                      >({{ activity.desc }})</span
                    >
                    <span>{{ activity.namee }}</span>
                    <el-button
                      type="text"
                      v-if="activity.apptWarehouseOrderId"
                      @click="GetshowText(activity)"
                      >{{ $t("i18n_Inquiry_receipt") }}</el-button
                    >
                  </div>
                </el-timeline-item>
              </el-timeline>
            </el-collapse-item>
          </el-collapse>
          <!-- 二维数组轨迹 end-->
          <!-- 相同轨迹 -->
          <div
            style="width: 100%; float: left"
            v-if="!activities[0].fbxBoxTrailDTOList"
          >
            <el-card class="box-card">
              <div
                style="width: 100%; float: left; margin-bottom: 15px"
                v-for="(item, index) in activities"
                :key="index"
                class="text item"
              >
                <div style="float: left">
                  <span style="padding-left: 15px; color: #999"
                    >{{ item.occurrenceDate }}
                    <span style="margin-left: 10px">{{
                      item.occurrenceTime
                    }}</span>
                  </span>
                </div>
                <div style="float: left">
                  <span style="padding-left: 15px; font-weight: bold">{{
                    item.name
                  }}</span>
                  <span style="margin-left: 10px" v-if="item.desc"
                    >({{ item.desc }})</span
                  >
                  <span style="margin-left: 20px">{{ item.namee }}</span>
                  <span
                    style="color: #5ab53c; cursor: pointer"
                    v-if="item.apptWarehouseOrderId"
                    @click="GetshowText(item)"
                  >
                    {{ $t("i18n_Inquiry_receipt") }}</span
                  >
                </div>
              </div>
            </el-card>
          </div>
          <!-- 相同轨迹 end-->
        </div>
        <!-- 海运散货轨迹 -->
        <div v-if="trackTableData.length && trackType === 3">
          <el-table
            border
            :data="trackTableData"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#F3F3F3' }"
            class="trackTable"
            style="width: 961px"
          >
            <el-table-column
              :label="$t('i18n_Order_Status')"
              prop="orderStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <!-- <el-table-column :label="$t('i18n_Pickup_Status')" prop="THStatus" width="120px" align="center"></el-table-column> -->
            <el-table-column
              :label="$t('i18n_warehouse_status')"
              prop="JCStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_Booking_status')"
              prop="PGStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_Shipping_Schedule_Status')"
              prop="DGStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_Trunk_status')"
              prop="GXStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_Customs_clearance_status')"
              prop="QGStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_Distribution_Center_Status')"
              prop="FBZXStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_delivery_status')"
              prop="PSStatus"
              width="120px"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <!-- 空运轨迹 -->
        <div v-if="trackTableData.length && trackType === 2">
          <el-table
            border
            :data="trackTableData"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#F3F3F3' }"
            class="trackTable"
          >
            <el-table-column
              :label="$t('i18n_Order_Status')"
              prop="orderStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_Pickup_Status')"
              prop="THStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_warehouse_status')"
              prop="JCStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_Booking_Status')"
              prop="PGStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_China_Hong_Kong_Status')"
              prop="DGStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_Trunk_status')"
              prop="GXStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_Customs_clearance_status')"
              prop="QGStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_Distribution_Center_Status')"
              prop="FBZXStatus"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('i18n_delivery_status')"
              prop="PSStatus"
              width="120px"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 轨迹搜索结果END -->
    </div>

    <loginType ref="child"></loginType>
    <el-dialog
      :title="$t('i18n_Shipping_Instructions')"
      :visible.sync="dialogTableVisible"
    >
      <div class="showText" v-html="sendgoodsremarks"></div>
    </el-dialog>

    <div class="dialogCover" @click.self="closeMyDialog()" v-if="showMydialog">
      <div class="myDialog">
        <!-- header  -->
        <div style="display: flex; justify-content: space-between">
          <span style="font-weight: 600">{{
            getLIstType === "PS" ? "派送地址" : "提货地址"
          }}</span>
          <i
            class="el-icon-close"
            @click="closeMyDialog()"
            style="cursor: pointer"
          ></i>
        </div>
        <!-- body   -->
        <div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin: 20px 0;
            "
          >
            <div>
              <el-input
                clearable
                @clear="getPeopletable()"
                v-model="nameOrPhone"
                @keyup.native="searchNameOrPhone"
                placeholder="请输入姓名或电话"
                size="medium"
                style="width: 250px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <el-button slot="append" type="primary">搜索</el-button>
              </el-input>
            </div>

            <el-button size="medium" plain type="primary" @click="showAdd(true)"
              >新增地址</el-button
            >
          </div>
          <!-- 新增或编辑 -->
          <div
            v-if="edit"
            style="
              background-color: #fff;
              border-radius: 20px;
              padding: 20px;
              box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
            "
          >
            <div style="width: 85%; margin: 0 auto; max-width: 500px">
              <el-row
                :gutter="20"
                style="margin-bottom: 8px; margin-left: 1px; display: flex"
              >
                <div style="display: flex">
                  <div
                    class="grid-content"
                    style="margin-right: 35px; min-width: 50px"
                  >
                    <span style="line-height: 40px">联系人</span>
                  </div>

                  <div class="grid-content">
                    <el-input
                      v-model="submitForm.name"
                      placeholder="请输入联系人"
                    ></el-input>
                  </div>
                </div>
                <div style="display: flex">
                  <div
                    class="grid-content"
                    style="
                      margin-left: 10px;
                      margin-right: 10px;
                      min-width: 60px;
                    "
                  >
                    <span style="line-height: 40px">联系方式</span>
                  </div>

                  <div class="grid-content">
                    <el-input
                      v-model="submitForm.tel"
                      placeholder="请输入联系方式"
                    ></el-input>
                  </div>
                </div>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <span style="line-height: 40px">联系地址</span>
                  </div></el-col
                >
                <el-col :span="18">
                  <div class="grid-content">
                    <el-cascader
                      v-if="getLIstType == 'PS'"
                      :options="jackPsCitylist"
                      placeholder="请选择派送地址"
                      v-model="value"
                      clearable
                      @change="handleChange"
                      :props="props"
                    >
                    </el-cascader>
                    <el-cascader
                      v-else
                      :options="jackCitylist"
                      placeholder="请选择提货地址"
                      v-model="value"
                      clearable
                      @change="handleChange"
                      :props="props"
                    >
                    </el-cascader>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <div
                      style="line-height: 40px; width: 10px; height: 10px"
                    ></div></div
                ></el-col>
                <el-col :span="18"
                  ><div class="grid-content">
                    <el-input
                      v-model="submitForm.address"
                      type="textarea"
                      rows="2"
                      placeholder="请输入详细地址"
                    ></el-input></div
                ></el-col>
              </el-row>
              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <span style="line-height: 40px">标签</span>
                  </div></el-col
                >
                <el-col :span="18"
                  ><div class="grid-content">
                    <el-input
                      v-model="submitForm.tag"
                      placeholder="请输入标签"
                    ></el-input></div
                ></el-col>
              </el-row>

              <div style="width: 330px; margin: 0 auto; text-align: center">
                <div style="display: flex">
                  <el-checkbox
                    text-color="#5AB53C"
                    v-model="submitForm.isdefault"
                    style="margin-right: 10px"
                  ></el-checkbox>
                  <span style="display: block; margin-bottom: 8px">
                    设置为默认地址
                  </span>
                </div>
                <el-button
                  @click="addAddr"
                  style="
                    background: #5ab53c;
                    border: 1px solid #5ab53c;
                    border-radius: 5px;
                    color: #fff;
                  "
                  >{{ this.submitForm.id ? "修改" : "新增" }}</el-button
                >
                <el-button type="info" @click="showAdd(false)">关闭</el-button>
              </div>
            </div>
          </div>

          <el-table
            v-if="!edit"
            @row-click="rowClick"
            size="mini"
            height="300"
            tooltip-effect="dark"
            :data="tableData"
            max-height="200"
            highlight-current-row
            border
            ref="Table"
            style="width: 100%; overflow: hidden"
          >
            <el-table-column
              label="姓名"
              width="100"
              align="center"
              prop="name"
            >
            </el-table-column>
            <el-table-column label="电话" width="120" align="center" prop="tel">
            </el-table-column>
            <el-table-column
              label="联系地址"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.parvince }}
                {{ scope.row.country }}
                {{ scope.row.city }}
                {{ scope.row.area }}
                {{ scope.row.address }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="160">
              <!-- <template slot="header" slot-scope="scope">
              <el-input
                v-model="search"
                size="mini"
                placeholder="请输入姓名"
              />
            </template> -->
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="setDefault(scope.row)"
                >
                  <span
                    :style="
                      scope.row.isdefault ? 'color:#604AFF' : 'color:#9A9A9A'
                    "
                    >{{ scope.row.isdefault ? "默认" : "设为默认" }}</span
                  >
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="!edit"
            style="margin-top: 20px"
            title="点击任意一行选择您的地址"
            type="info"
            center
            show-icon
          >
          </el-alert>
        </div>

        <!-- footter  -->
      </div>
    </div>
    <!-- 箱子轨迹 -->
    <el-dialog
      style="padding-left: 100px"
      title="查看回执"
      :visible.sync="dialogVisible"
      :width="`${imagesList.length ?imagesList.length>3 ? 660 : imagesList.length * 220: 660}px`"
    >
      <div style="display: flex;flex-wrap: wrap;gap: 10px;">
        <el-image
          v-for="(item, index) in imagesList"
          :key="index"
          :src="item"
          :preview-src-list="imagesList"
          style="width: 200px;"
          fit="contain"
        />
      </div>
      <el-table :data="fileList" border v-if="fileList.length" style="margin-top: 20px;">
        <el-table-column label="文件名" prop="name"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-link :underline="false" type="primary" @click="fileDownload(scope.row.src)">下载</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="!imagesList && !fileList.length"
        title="未上传回执"
        type="info"
        center
        show-icon
      >
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" size="default" @click="downPic">下载图片</el-button> -->
        <el-button type="primary" @click.stop="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 引流模块 -->
    <div class="clickPointer" v-if="!topType">
      <!-- 原 click_pointer_con 广告位（九域）已禁用，替换为下方 fyb_zbx 图片推广位 -->
      <template v-if="false">
        <div class="click_pointer_con" @click="goJiuYu" title="www.19jiuyu.com">
          <div class="click_pointer_up">
            <div class="click_up_content">
              <!-- 中东专线找<span>亦邦</span> ,&nbsp;全球到门找<span>九域</span> -->
              走美国FBA海运&nbsp;,&nbsp;享账期结算权益
            </div>
            <img
              class="bottom_icon"
              src="../../assets/images/jiuSign.png"
              alt=""
            />
          </div>
          <div class="click_pointer_down">
            <div class="click_down_left">亦邦旗下-全球到门快运网</div>
            <div class="click_down_right">www.19jiuyu.com</div>
          </div>
          <!-- 九域小龙人 -->
          <img
            class="dragon_img"
            src="../../assets/images/jiuDragon.png"
            alt=""
          />
          <!-- 小手 -->
          <img
            class="click_pointer"
            src="../../assets/images/pointer.png"
            alt=""
          />
        </div>
      </template>
      <!-- fyb_zbx 图片推广位，点击跳转微信文章 -->
      <div class="click_pointer_con" @click="goFybZbx">
        <img
          class="fyb_zbx_img"
          src="../../assets/images/fyb_zbx.gif"
          alt=""
        />
      </div>
    </div>
    <!-- 箱子轨迹END -->
    <div
      v-show="!topType"
      style="
        text-align: center;
        margin-bottom: 20px;
        position: absolute;
        width: 100%;
        bottom: 10px;
        color: #ffffff;
      "
    >
      {{ $t("i18n_cititrans") }}
      <a
        style="color: #ffffff"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        >粤ICP备18003296号</a
      >
    </div>
  </div>
</template>

<script>
import qs from "qs";
import Utils from "../../../common/util.js";
import loginType from "../../../common/loginType";
import SHicon1 from "../../assets/images/SHicon1.png";
import ZGicon1 from "../../assets/images/ZGicon1.png";
import KYicon1 from "../../assets/images/KYicon1.png";
import FBAicon1 from "../../assets/images/FBAicon1.png";
import SHicon2 from "../../assets/images/SHicon2.png";
import ZGicon2 from "../../assets/images/ZGicon2.png";
import KYicon2 from "../../assets/images/KYicon2.png";
import FBAicon2 from "../../assets/images/FBAicon2.png";
import { mapState } from 'vuex'
import fileDownload from "js-file-download";
export default {
  components: {
    loginType,
  },
  data() {
    return {
      // 轨迹查询Loading
      trackLoading: false,
      // 整柜开始 Jack
      going: false,
      checkList: [],
      fclPriceList: [], //查价
      weekList: [
        { label: "周一", value: 1 },
        { label: "周二", value: 2 },
        { label: "周三", value: 3 },
        { label: "周四", value: 4 },
        { label: "周五", value: 5 },
        { label: "周六", value: 6 },
        { label: "周日", value: 7 },
      ], //班期
      dayList: [
        { label: "七天内", value: 7 },
        { label: "十五天内", value: 15 },
        { label: "三十天内", value: 30 },
      ], //预计开船
      shipCompanies: [], //预计船公司
      //整柜查价请求参数
      fclRequestParams: {
        carriers: [], // 船公司
        days: "", // 预计开船
        etdDateFrom: "",
        etdDateTo: "",
        etdWeeks: [], // 班期
        pod: "",
        pol: "",
        priceQueryParams: {
          // 是否勾选拖车和拖柜
        },
      },
      startPorts: [], //起运港
      endPorts: [], //目的港
      // 整柜end Jack

      imagesList: [],
      fileList: [],
      boxGuijiLIst: [], //箱子轨迹列表
      dialogVisible: false,
      BoxLIstwrap: [],
      gotop: false,
      activities: [],
      trackTableData: [],
      trackType: 1,
      inos: "",
      cascaderKey: 1,
      FBAdataprops: {
        //定义 联级选择器的国家和区域获取name
        label: "namec",
        value: "id",
        children: "datWarehouseDTOList",
      },
      toFBAdataprops: {
        label: "namec",
        value: "id",
        children: "children",
      },
      // jack
      registerPolicyDialog: false,
      getLIstType: "",
      props: {
        value: "namec",
        label: "namec",
      },
      value: [],
      countLIst_T: {
        address: "",
        area: "",
        city: "",
        customerid: "",
        id: "",
        isdefault: null,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      countLIst_C: {
        address: "",
        area: "",
        areaId: "",
        city: "",
        cityId: "",
        country: "",
        countryId: "",
        customerid: "",
        id: "",
        isdefault: null,
        name: "",
        tag: "",
        tel: "",
      },
      showMydialog: false,
      jackPsCitylist: [],
      jackCitylist: [],
      submitForm: {
        address: "",
        area: "",
        city: "",
        customerid: 0,
        id: 0,
        isdefault: false,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      edit: false,
      nameOrPhone: "",
      tableData: [],
      tempTableData: [],
      shouSelectAddr: false,
      checked1: false,
      checked2: false,
      defaultParams: {
        label: "namec",
        value: "id",
        children: "children",
      },
      navLIst: [{ name: "i18n_Logistics_Product" }, { name: "i18n_track_status" }],
      Typelist: [
        { name: "i18n_FBA", url1: FBAicon1, url2: FBAicon2, index: 3 },
        { name: "i18n_Marine_bulk_cargo", url1: SHicon1, url2: SHicon2, index: 0, disabled: true, },
        // {
        //   name: "i18n_Full_container_load",
        //   disabled: true,
        //   url1: ZGicon1,
        //   url2: ZGicon2,
        //   index: 1,
        // },
        {
          disabled: true,
          name: "i18n_International_Air_Freight",
          url1: KYicon1,
          url2: KYicon2,
          index: 2,
        },
      ],

      // jack end
      cityshowlist: [],
      PScityshowlist: "",
      citylist: [], //提货省市区
      Pscitylist: [], //派送区域
      cangkuLIst: [],
      thatALLcklist: [],
      thatFBAcklist: [],
      FBAfromCk: [],
      FBAtoCk: [],
      WarehousItemID: null, //选择的目的港仓库
      Sonindex: 3,
      activeIndex: null,
      sendgoodsremarks: "",
      dialogTableVisible: false,
      cangkuShow: null, //展示仓库
      welickShow: null, //展示仓库
      topType: false,
      lableData: [],
      pollandId: "",
      guojiaData: [],
      WarehouseList: [],
      avtive: 0,
      input: "",
      weight: "",
      cbm: "",
      deliveryDTO: {
        //	配送三级地址信息
        podlandAreaId: "",
        podlandCityId: "",
        podlandId: "",
      },
      pickUpDTO: {
        //提货三级地址信息
        area: "",
        city: "",
        province: "",
      },
      LCLWarehouseList: [],
      KYWarehouseList: [],
    };
  },
  watch: {
    lang(newVal, oldVal) {
      // this.FBAdataprops.label = this.lang === 'zh' ? 'namec' : 'namee'
      // this.toFBAdataprops.label = this.lang === 'zh' ? 'namec' : 'namee'
      // this.defaultParams.label = this.lang === 'zh' ? 'namec' : 'namee'
      if (this.Sonindex == 0 || this.Sonindex == 2) {
        this.pollandId = ''
        this.WarehousItemID = null
        this.getCangku()
        this.getWarehouse()
      } else if (this.Sonindex == 1) {
        this.fclRequestParams.pol = ''
        this.fclRequestParams.pod = ''
      } else {
        this.thatALLcklist = []
        this.thatFBAcklist = []
        this.getFBAfromCk()
        this.getFBAtoCk()
      }
    },
    topType(newVal, oldVal) {
      this.$store.commit('setTopType', newVal)
    }
  },
  computed: {
    isSelected() {
      if (this.checked1 || this.checked2) {
        return false;
      }
      return true;
    },
    ...mapState(['lang'])
  },
  destroyed() {

  },
  mounted() {
    // console.log("welcome back")
  },
  methods: {
    goJiuYu() {
      window.open('https://www.19jiuyu.com/')
    },
    goFybZbx() {
      // 上报宣传链接点击次数（不阻塞跳转）
      this.reportClick('巴西引流GIF图片')
      window.open('https://mp.weixin.qq.com/s/6gENqDBhwDsRhZ-0zKbY7w')
    },
    // 上报宣传链接点击：一个客户一天一条；未登录 customerId=0，后端负责按天 upsert
    reportClick(linkName) {
      let customerId = 0
      const auth = sessionStorage.getItem("Authorization")
      if (auth) {
        try {
          customerId = JSON.parse(auth).customerid || 0
        } catch (e) {
          customerId = 0
        }
      }
      this.axios
        .post("busOmsClickStatistics/add", {
          linkName: linkName,
          customerId: customerId,
        })
        .catch(() => {
          // 点击统计失败不影响跳转
        })
    },
    // downPic() {
    //   // this.drawALoad("https://fastmarket.oss-cn-shenzhen.aliyuncs.com/oss/static/other/1/images/baseMap_index.jpg", 't2')
    //   // this.imagesList.forEach((v, i) => {
    //   //   this.drawALoad(v, `回执${i+1}`)
    //   // })
    // },
    // drawALoad(url, name) {
    //   let timeStamp = new Date().getTime();
    //   let Img = new Image();
    //   Img.src = url + '?' + timeStamp;
    //   // 解决控制台跨域报错的问题
    //   Img.crossOrigin = 'Anonymous';
    //   let ext = Img.src.substring(Img.src.lastIndexOf('.') + 1).toLowerCase();
    //   Img.onload = function () {
    //     var canvas = document.createElement('canvas'); //创建canvas元素
    //     canvas.width = Img.width;
    //     canvas.height = Img.height;
    //     canvas.getContext('2d').drawImage(Img, 0, 0, Img.width, Img.height);
    //     //转换图片为dataURL
    //     let url = canvas.toDataURL(`image/${ext}`)
    //     let a = document.createElement("a")
    //     let event = new MouseEvent("click")
    //     a.download = name
    //     a.href = url
    //     a.dispatchEvent(event)
    //   }
    // },
    // 整柜查价变化清空
    fclChange() {
      this.fclPriceList = [];
    },

    GetshowText(item) {

      this.axios
        .post(
          `/fbxTrail/findApptWarehouseOrderReceipt/${item.apptWarehouseOrderId}`
        )
        .then((res) => {
          if (res.data.code == "200") {
            const list = res.data.datas;
            const picSuffix = ['.jpg', '.png', '.jpeg', '.gif', '.bmp']

            // 清空之前的列表
            this.imagesList = [];
            this.fileList = [];

            // 遍历数据，根据文件后缀分类
            list.forEach(url => {
              // 去除URL中的查询参数（如?Expire=xxx），获取纯文件路径
              const urlWithoutParams = url.split('?')[0];
              // 获取文件后缀并转为小写
              const fileExtension = urlWithoutParams.substring(urlWithoutParams.lastIndexOf('.')).toLowerCase();

              // 判断是否为图片格式
              if (picSuffix.includes(fileExtension)) {
                this.imagesList.push(url);
              } else {
                // 提取文件名：从最后一个 '/' 之后到 '?' 之前的部分
                const fileNameEncoded = urlWithoutParams.substring(urlWithoutParams.lastIndexOf('/') + 1);
                // 对URL编码的文件名进行解码，支持中文文件名
                const fileName = decodeURIComponent(fileNameEncoded);
                this.fileList.push({
                  name: fileName,
                  src: url
                });
              }
            });

            this.dialogVisible = true
          } else {
            this.$message(res.data.message);
          }
        })
        .catch((res) => { });
    },
    fileDownload(src) {
      window.open(src)
    },
    showType(num) {
      if (num == 1) {
        //回到首页
        this.topType = false;
        this.avtive = 0;
        this.lableData = [];
        this.activities = [];

        // --------清空散货 和 FBX 起运地目的仓  空运后期添加
        this.WarehousItemID = null;
        this.pollandId = "";
        this.thatALLcklist = [];
        this.thatFBAcklist = [];
        // 清空整柜
        this.fclRequestParams.clearMethods(); //清空整柜
        this.fclPriceList = []; //清空整柜
        this.fclRequestParams.carriers = [];
        this.fclRequestParams.days = "";
        this.fclRequestParams.etdWeeks = [];
        // 清空整柜
      } else {
        //回到轨迹
        this.topType = false;
        this.avtive = 1;
        this.lableData = [];
        this.activities = [];
      }
      this.trackTableData = []
    },
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    Searchgj() {
      this.trackLoading = true
      this.axios
        .post(`/track/newQueryCommonTrackByNo/${this.inos}`, {}, {
          headers: { language: this.lang }
        })
        .then((res) => {
          this.activities = []
          this.trackTableData = []
          if (res.data.code == "200") {
            this.trackType = res.data.trackType
            this.topType = true; // 动态更改搜索框往上移
            if (res.data.trackType === 1) {
              if (res.data.data) {
                res.data.data.forEach((item) => {
                  if (item.fbxBoxTrailDTOList) {
                    item.fbxBoxTrailDTOList.forEach(_item => {
                      this.$set(_item, "color", "#909399");
                    })
                    item.fbxBoxTrailDTOList[0].color = "#409EFF";
                  }
                });
                this.activities = res.data.data;
                this.trackLoading = false
              } else {
                this.trackLoading = false
                this.activities = [];
              }
            } else {
              this.trackDataFormat(res)
              this.trackLoading = false
            }
          } else {
            this.trackLoading = false
            this.$message(res.data.message);
          }
        })
        .catch((res) => {
          this.trackLoading = false
        });
    },
    // 修改选项tab
    changeselect() {

      this.pollandId = "";
      this.WarehousItemID = null;
      this.thatALLcklist = [];
      this.thatFBAcklist = [];
      this.lableData = [];
      this.fclRequestParams.clearMethods(); //整柜清空起运和目的港
    },
    getFBAcount() {
      // FBA查询报价
      this.checked1 = false;
      this.checked2 = false;
      this.countLIst_C = {};
      //查询货物类型
      if (!this.thatALLcklist)
        return this.$message({ message: this.$t('i18n_Please_choose_original_wareohuse'), type: "warning" });
      if (!this.thatFBAcklist)
        return this.$message({ message: this.$t("i18n_please_choose_your_destination"), type: "warning" });
      let params = {};
      // localStorage.removeItem("FeeLIst");
      params = {
        pollandId: this.thatALLcklist[1], //入仓仓库id,
        podlandId: this.thatFBAcklist[2], //目的地仓库
        customerId: sessionStorage.getItem("Authorization")
          ? JSON.parse(sessionStorage.getItem("Authorization")).customerid
          : "", //客户id
      };
      this.axios
        .post("/FBAfee/queryFBAQuotedPriceInfo", params, {
          headers: { language: this.lang }
        })
        .then((res) => {

          if (res.data.code == "200") {
            if (res.data.datas) {
              this.lableData = res.data.datas;
              this.topType = true; // 动态更改搜索框往上移
              localStorage.setItem("isGlobalDelivery", JSON.stringify(res.data.datas[0].isGlobalDelivery));
            } else {
              this.$message({
                message: this.$t("i18n_no_quotation_contact_salesman"),
                type: "warning",
              });
            }
          } else {
            this.$message(res.data.message);
          }
        })
        .catch((res) => { });
    },
    changefromFABck(list) {

      this.FBAfromCk.forEach((item) => {
        if (item.id == list[0]) {
          this.cangkuShow = item.datWarehouseDTOList.find((_item) => {
            return _item.id == list[1];
          });
        }
      });
      this.cascaderKey++;
      localStorage.setItem("fromFABck", JSON.stringify(this.cangkuShow));
      this.lableData = [];
    },
    changetoFABck(list) {

      this.lableData = [];
      this.FBAtoCk.forEach((item, index) => {
        if (item.id == list[0]) {
          item.children.forEach((_item) => {
            if (_item.id == list[1]) {
              _item.children.forEach((res) => {
                if (res.id == list[2]) {
                  this.welickShow = res;
                }
              });
            }
          });
        }
      });
      localStorage.setItem("toFABck", JSON.stringify(this.welickShow));
      localStorage.setItem('toCountryId', list[0])
    },
    // jack methods start
    // 关闭弹窗
    closeMyDialog() {
      if (this.edit) {
        this.$confirm("当前为编辑状态,是否关闭?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.showMydialog = false;
            this.showAdd(false);
          })
          .catch((res) => { });
      } else {
        this.showMydialog = false;
      }
    },
    // 显示弹窗
    showDialogOfMine(type) {
      if (!sessionStorage.getItem("Authorization")) {
        this.$refs.child.showDialog(2);
      } else {
        // 每次打开都获取一次级联地址列表
        this.getPopList();
        if (type === "PS") {
          this.getLIstType = type;
          this.getPeopletable(type);
        } else {
          this.getLIstType = "";
          this.getPeopletable();
        }

        this.showMydialog = true;
      }
    },
    // 校验
    very() {
      if (!this.submitForm.name) {
        this.$message.info("联系人不能为空！");
        return false;
      }
      // 派送不校验
      if (this.getLIstType != "PS") {
        if (!/^1[3456789]\d{9}$/.test(this.submitForm.tel)) {
          this.$message.info("手机号码有误，请重填");
          return false;
        }
      }

      // 城市
      if (!this.submitForm.city) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      // 区
      if (!this.submitForm.area) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      if (!this.submitForm.address) {
        this.$message.info("详细地址不能为空！");
        return false;
      }
      if (this.submitForm.tag) {
        if (this.submitForm.tag.length > 5) {
          this.$message.info("标签长度不能超过五个字符");
          return false;
        }
      }

      return true;
    },
    // 显示新增
    showAdd(type) {
      if (type) {
        this.edit = true;
      } else {
        this.edit = false;
      }

      this.value = [];
      for (let key in this.submitForm) {
        this.submitForm[key] = "";
      }
    },
    //  edit
    handleEdit(index, item) {
      this.value = [];
      let temp = JSON.stringify(item);
      this.submitForm = JSON.parse(temp);
      this.value.push(
        this.getLIstType == "PS"
          ? this.submitForm.country
          : this.submitForm.parvince,
        this.submitForm.city,
        this.submitForm.area
      );
      this.edit = true;
    },
    // add
    addAddr(id) {
      if (!this.very()) {
        return;
      }
      if (!this.submitForm.id) {
        delete this.submitForm.id;
      }
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      // 新增
      this.submitForm.customerid = user.customerid;
      // 判断是否是派送
      let path = "addOrUpdateDelivery";
      if (this.getLIstType === "PS") {
        path = "addOrUpdateConsigner";
      }
      this.axios
        .post(`/customer/${path}`, this.submitForm, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.edit = false;
            this.value = [];
            this.getPeopletable();
            for (let key in this.submitForm) {
              this.submitForm[key] = "";
            }
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => { });
    },
    // 设为默认
    setDefault(item) {
      if (item.isdefault) {
        return this.$message.info("已经是默认地址");
      }
      this.axios
        .post(`/customer/updateAddressDefault?addressId=${item.id}`, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.getPeopletable();
            this.$message.success("设置成功！");
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => { });
    },
    TopathHY() {
      //海运进一步查价

      // 如果选了送货
      if (this.checked2 && this.countLIst_C.name) {
        //校验路线正确
        let params = {};
        let that = this;
        params = {
          recgoodsCountry: this.countLIst_C.country,
          toWarehouseId: this.welickShow.id,
        };
        this.axios
          .post(
            `/busLcljobsBefore/validateWarehouseCountry`,
            qs.stringify(params)
          )
          .then((res) => {
            if (res.data.code == "200") {
              localStorage.removeItem("todoordate");
              localStorage.removeItem("PSFmoney");

              if (this.Sonindex == 0) {
                this.$router.push({
                  name: "bulkCargo",
                  params: {
                    weight: this.weight,
                    cbm: this.cbm,
                    PSFmoneyChecked: this.checked2,
                    tuoCheDataChecked: this.checked1,
                  },
                });
                // 空运
              } else if (this.Sonindex == 2) {
                this.$router.push({
                  name: "AirCargoIndex",
                  params: {
                    weight: this.weight,
                    cbm: this.cbm,
                    send: this.checked2,
                    pickUp: this.checked1,
                  },
                });
              }
            } else {
              this.$alert(res.data.message, "错误", {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.$message({
                    type: "info",
                    message: `请重新选择派送地址`,
                  });
                },
              });
            }
          })
          .catch((res) => {
            this.$message.info("服务器繁忙");
          });
      } else {
        localStorage.removeItem("countLIst_C");
        localStorage.removeItem("todoordate");
        localStorage.removeItem("PSFmoney");

        if (this.Sonindex == 0) {
          this.$router.push({
            name: "bulkCargo",
            params: {
              weight: this.weight,
              cbm: this.cbm,
              PSFmoneyChecked: this.checked2,
              tuoCheDataChecked: this.checked1,
            },
          });
          // 空运
        } else if (this.Sonindex == 2) {
          this.$router.push({
            name: "AirCargoIndex",
            params: {
              weight: this.weight,
              cbm: this.cbm,
              send: this.checked2,
              pickUp: this.checked1,
            },
          });
        }
      }
    },
    goQuery() {
      // 进一步查价
      if (!sessionStorage.getItem("Authorization")) {
        this.$refs.child.showDialog(2);
      } else {
        if (this.Sonindex == 0 || this.Sonindex == 2) {
          this.TopathHY();
        } else if (this.Sonindex == 3) {
          //FBA
          localStorage.removeItem("FeeLIst");
          localStorage.removeItem("boxLIst");
          this.$router.push({
            name: "FbaCargo",
            params: {
              THFchecked: this.checked1,
            },
          });
        }
      }
    },
    getFiledata() {
      let saveData = JSON.stringify(
        {
          // 0:物流产品，1：查轨迹
          fatType: '' + this.avtive,
          //  产品类型：3：电商，2：国际空运，0：海运散货
          sonType: '' + this.Sonindex
        }
      )
      this.$store.commit('setProductType', saveData)
      localStorage.setItem("productType", saveData)
      //整柜的情况
      if (this.Sonindex == 1) {
        this.getShipCompanies();
        this.getFiledataForFcl();
        return;
      }

      if (this.Sonindex == 3) {
        //调用fba查价
        this.getFBAcount();
      } else {
        //海运散货查价
        // jack 每次查价前清空勾选地址和其他信息 显示列表
        this.checked1 = false;
        this.checked2 = false;
        this.countLIst_C = {};
        //查询货物类型
        if (this.pollandId == "")
          return this.$message({ message: this.$t('i18n_Please_choose_original_wareohuse'), type: "warning" });
        if (!this.WarehousItemID)
          return this.$message({
            message: this.$t("i18n_please_choose_your_destination"),
            type: "warning",
          });
        let params = {};
        localStorage.removeItem("FeeLIst");
        params = {
          pollandId: this.pollandId, //入仓仓库id,
          podlandId: this.WarehousItemID[1], //目的城市
          customerId: sessionStorage.getItem("Authorization")
            ? JSON.parse(sessionStorage.getItem("Authorization")).customerid
            : "", //客户id
          deliveryDTO: this.deliveryDTO, //cityshowlist
          pickUpDTO: this.pickUpDTO,
        };
        let url = {
          2: "/KYFee/getAirFeeQuoteListInfo",
          0: "/feeitem/getSeaFeeQuoteListInfo",
          // 1: "/KYFee/getAirFeeQuoteListInfo", // 暂时先上空运
        };
        // jack
        // 如果重新查询了，之前的存本地的都清除 空运的
        if (this.Sonindex == 2) {
          // 增值服务
          localStorage.removeItem("moreFeeListForAir");
          // 商品
          localStorage.removeItem("GoodListForAir");
          // 派送费
          localStorage.removeItem("sendFeeForAir");
          // 提货费
          localStorage.removeItem("pickFeeForAir");
          // 运费
          localStorage.removeItem("transportFeeForAir");
          // 入仓时间
          localStorage.removeItem("inwarehousetime");
          // 备注
          localStorage.removeItem("remarksForAir");
        }

        // 如果是整柜用整个的请求params
        // this.Sonindex == 2 && (params = this.fclRequestParams);
        // jack end
        this.axios
          .post(url[`${this.Sonindex}`], params, { headers: { language: this.lang } })
          .then((res) => {
            if (res.data.code == "200") {
              if (res.data.datas) {
                this.lableData = res.data.datas;
                this.topType = true; // 动态更改搜索框往上移
              } else {
                this.$message({
                  message: this.$t("i18n_no_quotation_contact_salesman"),
                  type: "warning",
                });
              }
            } else {
              this.$message(res.data.message);
            }
          })
          .catch((res) => { });
      }
    },
    onFclSelectChange() {
      this.fclPriceList = []; //清空整柜
      this.fclRequestParams.carriers = [];
      this.fclRequestParams.days = "";
      this.fclRequestParams.etdWeeks = [];
      // 清空整柜
    },
    // 整柜报价查询
    getFiledataForFcl() {
      // this.fclRequestParams.clearMethods();  //清空方法中调用即可
      this.shipCompanies.length &&
        this.shipCompanies.forEach((item) => {
          item.disabled = true;
        });
      this.shipCompanies.splice();
      return new Promise((resPromise, rej) => {
        this.axios
          .post(`/FCLFee/getFclOfferPriceInfo`, this.fclRequestParams)
          .then((res) => {
            if (res.data.code == "200") {
              if (res.data.datas.length) {
                this.fclPriceList = res.data.datas;
                this.topType = true; // 动态更改搜索框往上移
                resPromise(false);
              } else {
                this.$message({
                  message: this.$t("i18n_no_quotation_contact_salesman"),
                  type: "warning",
                });
                resPromise(true);
              }
            } else {
              this.$message(res.data.message);
              rej();
            }
          })
          .catch((res) => { });
      });
    },
    // 获取省市区列表
    getPopList() {
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      //  获取国外
      this.axios
        .post(`filedata/findThirdLevelAddress`, {}, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.jackPsCitylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });

      this.axios
        .post(`filedata/filedataProvinces`, {}, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.jackCitylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });
    },
    // 级联选择器方法
    handleChange(value) {
      if (this.getLIstType === "PS") {
        this.submitForm.country = value[0];
      } else {
        this.submitForm.parvince = value[0];
      }
      this.submitForm.city = value[1];
      this.submitForm.area = value[2];
    },
    // 模糊搜索
    searchNameOrPhone() {
      if (!this.nameOrPhone) {
        return this.getPeopletable();
      }
      let temp = [];

      this.tempTableData.forEach((item, index) => {
        if (
          item.name.indexOf(this.nameOrPhone) != -1 ||
          item.tel.indexOf(this.nameOrPhone) != -1
        ) {
          temp.push(item);
        }
      });
      this.tableData = temp;
    },
    // 点击行
    rowClick(r) {
      if (this.getLIstType === "PS") {
        this.countLIst_C = r;
        localStorage.setItem("countLIst_C", JSON.stringify(this.countLIst_C));
      } else {
        this.countLIst_T = r;
        localStorage.setItem("countLIst_T", JSON.stringify(this.countLIst_T));
      }
      this.showMydialog = false;
    },

    // 删除地址
    handleDelete(index, row) {
      let that = this;
      this.$confirm("确定删除该联系人吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post(`/customer/delAddress/${row.id}`)
            .then((res) => {
              if (res.data.code == "200") {
                that.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.getPeopletable();
              } else {
                that.$message({
                  message: res.data.message,
                  type: "info",
                });
              }
            })
            .catch((res) => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
      // /customer/delAddress/{id}
    },
    getPeopletable() {
      //获取提货联系人
      let that = this;
      let customerId = sessionStorage.getItem("Authorization")
        ? JSON.parse(sessionStorage.getItem("Authorization")).customerid
        : "";
      let path = "addressListForDelivery";
      if (this.getLIstType === "PS") {
        path = "addressListForConsigner";
      } else {
        // 暂时不调这个接口
        return
      }
      this.axios
        .get(`/customer/${path}/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            // res.data.datas.forEach((item) => {
            //   this.$set(item, "changeType", false);
            // });
            this.tableData = res.data.datas;
            this.tempTableData = res.data.datas;
          } else {
          }
        })
        .catch((res) => { });
    },
    // jack methods end
    foreinHouseChange(e) { },
    // 修改tab
    changesonNav(index) {

      // 获取缓存目录
      let getStorageType = JSON.parse(localStorage.getItem('productType'))

      if (!getStorageType) {
        getStorageType = {
          // 0:物流产品，1：查轨迹
          fatType: '0',
          //  产品类型：3：电商，2：国际空运，0：海运散货
          sonType: '3'
        }
      }
      getStorageType.sonType = '' + index
      localStorage.setItem('productType', JSON.stringify(getStorageType))
      // if(index!=0) return this.$message.info('暂未开放')
      if (index == 1) {
        // if (process.env.NODE_ENV === "development") {
        //   //开发环境
        // } else {
        //   // 生产环境
        //   return this.$message.info('暂未开放')
        // }
        //整柜 去请求起运和目的list
        let startPortRequest = this.axios.get(`/busFCL/getPolPortList`);
        let endPortRequest = this.axios.get(`/busFCL/getPodPortList`);
        this.axios.all([startPortRequest, endPortRequest]).then(
          this.axios.spread((start, end) => {
            console.log(
              start.data.code == 200 &&
              start.data.datas.length &&
              (this.startPorts = start.data.datas)
            );
            console.log(
              end.data.code == 200 &&
              end.data.datas.length &&
              (this.endPorts = end.data.datas)
            );
          })
        );
      }
      //   return this.$message({ message: "暂未开放敬请期待", type: "warning" });
      // // 不一样就清除列表
      if (index != this.Sonindex) {
        this.lableData = [];
        this.topType = false;
        this.pollandId = ''
      }
      this.Sonindex = index;
      this.lableData = [];
      this.deliveryDTO.podlandAreaId = "";
      this.deliveryDTO.podlandCityId = "";
      this.deliveryDTO.podlandId = "";
      // ----
      this.pickUpDTO.area = "";
      this.pickUpDTO.city = "";
      this.pickUpDTO.province = "";
      this.cityshowlist = [];
      this.PScityshowlist = "";
      if (this.Sonindex === 0 || this.Sonindex === 2) {
        this.getWarehouse()
        this.WarehousItemID = []
      }
    },
    outStyle(index) {
      this.activeIndex = index;
    },
    showText(item) {
      this.dialogTableVisible = true;
      this.sendgoodsremarks = item.sendgoodsremarks;
    },
    keyupEvent(e, input) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      e.target.value = e.target.value.replace(/\.{2,}/g, ".");
      e.target.value = e.target.value.replace(/^\./g, "0.");
      e.target.value = e.target.value.replace(
        /^\d*\.\d*\./g,
        e.target.value.substring(0, e.target.value.length - 1)
      );
      e.target.value = e.target.value.replace(/^0[^\.]+/g, "0");
      e.target.value = e.target.value.replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
      this.input = e.target.value;
    },
    changeCk(id) {
      // 清空国外仓库
      // this.WarehousItemID = "";

      let obj = {};
      // obj = this.cangkuLIst.find((item) => {
      //   return item.id === id;
      // });
      if (this.Sonindex === 0) {
        obj = this.LCLWarehouseList.find(item => item.id === id)
      } else if (this.Sonindex === 2) {
        obj = this.KYWarehouseList.find(item => item.id === id)
      }
      this.cangkuShow = obj;
      localStorage.setItem("cangkuitem", JSON.stringify(obj));
      // this.topType = false;
      this.lableData = []; //清空查询列表
    },
    async handleClick(item) {

      localStorage.removeItem('checkDownloadType')
      localStorage.removeItem('goodTypeIds')
      localStorage.setItem('deliveryQuoteId', '')
      localStorage.setItem('deliveryService', '')
      //下单
      let PSFmoneyChecked = false;
      let tuoCheDataChecked = false;

      // 验证当前客户是否可用
      const customerId = sessionStorage.getItem("Authorization") ? JSON.parse(sessionStorage.getItem("Authorization")).customerid : ""
      if (!customerId) {
        this.$message.warning(this.$t('i18n_not_logged_in_login_first'))
        this.$store.commit('changeLogin', true)
      }
      // 重置货值与箱数
      this.$store.commit("setGoodsValue", {
        proValue: 0
      })
      this.$store.commit("setGoodsCount", {
        boxNum: 0
      })
      const result = await this.axios.get(`/corporation/checkCustomerIsAvailable/${customerId}`).catch(err => {

      })
      if (!result) {
        return
      }
      if (result.data.code !== 200) {
        this.$message.warning(result.data.message)
        return
      }

      if (!sessionStorage.getItem("Authorization")) {
        this.$refs.child.showDialog(2);
      } else {
        if (item.downloadType) localStorage.setItem('checkDownloadType', item.downloadType)
        if (item.goodTypeIds) localStorage.setItem('goodTypeIds', item.goodTypeIds)
        localStorage.setItem("checkProductId", JSON.stringify(item.productId))
        localStorage.setItem("goodsTypeName", JSON.stringify(item.goodstype));
        localStorage.removeItem("todoordate");
        localStorage.removeItem("PSFmoney");
        localStorage.removeItem("FeeLIst");
        if (this.Sonindex == 0) {
          //海运
          this.$store.commit('setProduct', item.productId)
          this.$store.commit('setProductInfo', item)
          this.$router.push({
            // name: "bulkCargo",
            name: 'newBulkCargo',
            query: {
              //   weight: this.weight,
              //   cbm: this.cbm,
              //   PSFmoneyChecked: PSFmoneyChecked,
              //   tuoCheDataChecked: tuoCheDataChecked,
              productId: item.productId
            },
          });
        } else if (this.Sonindex == 3) {
          localStorage.setItem(
            "transportTypeCode",
            JSON.stringify(item.transportTypeCode)
          );
          localStorage.removeItem("FeeLIst");
          localStorage.removeItem("boxLIst");
          localStorage.removeItem("countLIst_T");
          localStorage.removeItem("FBATransmoney");
          localStorage.removeItem("THFdata");
          this.$store.commit('setProductInfo', item)
          this.$router.push({
            name: "FbaCargo",
            params: {
              THFtype: tuoCheDataChecked,
              transportTypeCode: item.transportTypeCode,
            },
          });
          // 空运
        } else if (this.Sonindex == 2) {
          // 增值服务
          localStorage.removeItem("moreFeeListForAir");
          // 商品
          localStorage.removeItem("GoodListForAir");
          // 派送费
          localStorage.removeItem("sendFeeForAir");
          // 提货费
          localStorage.removeItem("pickFeeForAir");
          // 运费
          localStorage.removeItem("transportFeeForAir");
          // 入仓时间
          localStorage.removeItem("inwarehousetime");
          // 备注
          localStorage.removeItem("remarksForAir");
          this.$router.push({
            name: "newAirOrders",
            query: {
              // weight: this.weight,
              // cbm: this.cbm,
              // PSFmoneyChecked: PSFmoneyChecked,
              // tuoCheDataChecked: tuoCheDataChecked,
              productId: item.productId
            },
          });
        }
      }
    },
    getProvinces() {
      //获取国内
      let that = this;
      this.axios
        .post("/filedata/filedataProvinces")
        .then((res) => {
          if (res.data.code == "200") {
            that.citylist = res.data.datas;
          }
        })
        .catch((res) => { });
    },
    changeChinaCity(item) {
      //切换提货省市区
      this.lableData = [];
      this.pickUpDTO.province = item[0];
      this.pickUpDTO.city = item[1];
      this.pickUpDTO.area = item[2];
    },
    changeEmoCity(item) {
      this.lableData = [];
      this.deliveryDTO.podlandId = item[0];
      this.deliveryDTO.podlandCityId = item[1];
      this.deliveryDTO.podlandAreaId = item[2];
    },
    changeECk(ItemID) {
      // 转换成国外仓库ID
      // if (ItemID instanceof Array) {
      //   // ItemID = ItemID[1];
      //   this.WarehousItemID = ItemID[1];
      // }
      //切换目的地仓库
      let obj = {
        addressc: "",
        country: "",
        countryId: "",
        id: "",
        namec: "",
        namee: "",
        tel: "",
      };
      this.WarehouseList.forEach((item) => {
        if (item.id == ItemID[0]) {
          obj.country = item.namec;
          item.children.forEach((_item) => {
            if (_item.id == ItemID[1]) {
              obj.namec = _item.namec;
              obj.countryId = _item.parentid;
              obj.tel = _item.tel;
              obj.addressc = _item.addressc;
              obj.id = _item.id;
            }
          });
        }
      });
      this.welickShow = obj;
      localStorage.setItem("PScangkuitem", JSON.stringify(obj));
      // this.topType = false;
      this.lableData = [];
      // this.getPScount(id);
    },
    // getPScount(id) {
    //   //获取国外省市区
    //   let that = this;
    //   this.axios
    //     .post("/filedata/findThirdLevelAddress?podlandId=" + `${id}`)
    //     .then((res) => {
    //       console.log(res);
    //       if (res.data.code == "200") {
    //         if (res.data.datas.length > 0) {
    //           that.Pscitylist = res.data.datas;
    //         } else {
    //           that.Pscitylist = null;
    //         }
    //       } else {
    //       }
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },
    // handlechange(idlist) {
    //   this.lableData = []; //清空查询列表
    //   this.guojiaData = idlist;
    //   let guojiaData = {};
    //   let Citydata = {};
    //   this.topType = false;
    //   guojiaData = this.guojiaLIst.find((item) => {
    //     return item.id === idlist[0];
    //   });
    //   Citydata = guojiaData.children.find((item) => {
    //     return item.id === idlist[1];
    //   });
    //   this.guojiaShow = guojiaData;
    //   this.CityShow = Citydata;
    //   localStorage.setItem("Citydata", JSON.stringify(Citydata));
    //   localStorage.setItem("guojiaData", JSON.stringify(guojiaData));
    // },
    getFBAfromCk() {
      //获取fba起运地仓库
      this.axios
        .get("/warehouse/getAllWarehouseList", {
          headers: {
            language: this.lang
          }
        })
        .then((res) => {
          this.FBAfromCk = res.data.datas;
        })
        .catch((res) => { });
    },
    getFBAtoCk() {
      //获取fba仓库
      this.axios
        .get("/warehouse/getFBAWarehouseList", {
          headers: {
            language: this.lang
          }
        })
        .then((res) => {
          this.FBAtoCk = res.data.datas;
          // 特殊逻辑前端屏蔽电商模块--目的地--阿曼
          if (Array.isArray(this.FBAtoCk) && this.FBAtoCk.length > 0) {
            let findIndex = this.FBAtoCk.findIndex(item => {
              return item.namec == '阿曼'
            })
            if (findIndex !== -1) {
              this.FBAtoCk.splice(findIndex, 1)
            }
          }

        })
        .catch((res) => { });
    },
    getCangku() {
      //获取仓库
      this.axios
        .get("/warehouse/warehouseListAll", {
          headers: {
            language: this.lang
          }
        })
        .then((res) => {
          this.cangkuLIst = res.data.datas
        })
        .catch((res) => { });
    },
    getWarehouse() {
      this.axios
        // .get("/warehouse/overseasWarehouseList")
        // .get("/filedata/listPodCityByCounrtyId")
        .get(`/filedata/listLevelPodCity?busType=${this.Sonindex === 0 ? 'L' : 'KY'}`, {
          headers: { language: this.lang }
        })
        .then((res) => {
          this.WarehouseList = res.data.datas;
          this.WarehouseList.forEach(item => {
            item.label = item.namec
            item.value = item.id
          })
        })
        .catch((res) => { });
    },
    changeNav(index) {
      this.avtive = index;

      // 获取缓存目录
      let getStorageType = JSON.parse(localStorage.getItem('productType'))

      if (!getStorageType) {
        getStorageType = {
          // 0:物流产品，1：查轨迹
          fatType: '0',
          //  产品类型：3：电商，2：国际空运，0：海运散货
          sonType: '3'
        }
      }
      getStorageType.fatType = '' + this.avtive

      localStorage.setItem('productType', JSON.stringify(getStorageType))
    },
    getShipCompanies() {
      this.axios
        .get("/busFCL/getShipOwningCompany")
        .then((res) => {
          this.shipCompanies = res.data.datas;
          this.shipCompanies.length &&
            this.shipCompanies.forEach((item) => {
              item.disabled = false;
            });
        })
        .catch((res) => { });
    },
    async onCheckBoxChange(e, type) {
      // 如果没数据就删除先中的
      // 如果返回true 就删除
      this.going = false;
      if (this.going) {
        return;
      }
      // console.log(await this.getFiledataForFcl());
      // console.log(3);
      this.going = true;
      if (await this.getFiledataForFcl()) {
        switch (type) {
          case "shipCompanies":
            setTimeout(() => {
              this.fclRequestParams.carriers.indexOf(e[0]) == -1
                ? ""
                : this.fclRequestParams.carriers.splice(
                  this.fclRequestParams.carriers.indexOf(e[0]),
                  1
                );

              this.going = false;
            }, 1000);

            break;
          case "weekList":
            this.fclRequestParams.etdWeeks = e;
            break;
          case "dayList":
            this.fclRequestParams.days = e;
            break;
        }
      }
      this.shipCompanies.length &&
        this.shipCompanies.forEach((item) => {
          item.disabled = false;
        });
      this.shipCompanies.splice();
      // console.log(e, type);
    },
    trackDataFormat(response) { // 处理返回的轨迹数据
      this.tableData = []
      const arr = []
      const res = response.data.data.data
      for (let key in res) {
        const length = res[key] !== null && typeof res[key] == 'object' ? res[key].trails.length : 0
        arr.push(length)
      }
      let max = arr.reduce((a, b) => a > b ? a : b)
      // debugger
      for (let i = 0; i < max; i++) {
        const obj = {}
        if (i < res.trail01.trails.length) {
          obj.orderStatus = res.trail01.trails.length ? res.trail01.trails[i].statusc : ''
          obj.orderStatus += res.trail01.trails[i].dealData
          obj.orderStatus += res.trail01.trails[i].addressDec ? '(' + res.trail01.trails[i].addressDec + ')' : ''
        }
        if (res.trail02 && i < res.trail02.trails.length) {
          obj.THStatus = res.trail02.trails.length ? res.trail02.trails[i].statusc : ''
          obj.THStatus += res.trail02.trails[i].dealData
          obj.THStatus += res.trail02.trails[i].addressDec ? '(' + res.trail02.trails[i].addressDec + ')' : ''
        }
        if (i < res.trail1.trails.length) {
          obj.JCStatus = res.trail1.trails.length ? res.trail1.trails[i].statusc : ''
          obj.JCStatus += res.trail1.trails[i].dealData
          obj.JCStatus += res.trail1.trails[i].addressDec ? '(' + res.trail1.trails[i].addressDec + ')' : ''
        }
        if (i < res.trail2.trails.length) {
          obj.PGStatus = res.trail2.trails.length ? res.trail2.trails[i].statusc : ''
          obj.PGStatus += res.trail2.trails[i].dealData
          obj.PGStatus += res.trail2.trails[i].addressDec ? '(' + res.trail2.trails[i].addressDec + ')' : ''
        }
        if (i < res.trail3.trails.length) {
          obj.DGStatus = res.trail3.trails.length ? res.trail3.trails[i].statusc : ''
          obj.DGStatus += res.trail3.trails[i].dealData
          obj.DGStatus += res.trail3.trails[i].addressDec ? '(' + res.trail3.trails[i].addressDec + ')' : ''
        }
        if (i < res.trail4.trails.length) {
          obj.GXStatus = res.trail4.trails.length ? res.trail4.trails[i].statusc : ''
          obj.GXStatus += res.trail4.trails[i].dealData
          obj.GXStatus += res.trail4.trails[i].addressDec ? '(' + res.trail4.trails[i].addressDec + ')' : ''
        }
        if (i < res.trail5.trails.length) {
          obj.QGStatus = res.trail5.trails.length ? res.trail5.trails[i].statusc : ''
          obj.QGStatus += res.trail5.trails[i].dealData
          obj.QGStatus += res.trail5.trails[i].addressDec ? '(' + res.trail5.trails[i].addressDec + ')' : ''
        }
        if (i < res.trail6.trails.length) {
          obj.FBZXStatus = res.trail6.trails.length ? res.trail6.trails[i].statusc : ''
          obj.FBZXStatus += res.trail6.trails[i].dealData
          obj.FBZXStatus += res.trail6.trails[i].addressDec ? '(' + res.trail6.trails[i].addressDec + ')' : ''
        }
        if (i < res.trail7.trails.length) {
          obj.PSStatus = res.trail7.trails.length ? res.trail7.trails[i].statusc : ''
          obj.PSStatus += res.trail7.trails[i].dealData
          obj.PSStatus += res.trail7.trails[i].addressDec ? '(' + res.trail7.trails[i].addressDec + ')' : ''
        }
        this.trackTableData.push(obj)
      }
    },
    getLCLWarehouse() {
      this.axios.get('/warehouse/warehouseListLcl').then(res => {
        if (res.data.code === 200) {
          this.LCLWarehouseList = res.data.datas
        }
      })
    },
    getKYWarehouse() {
      this.axios.get('/warehouse/warehouseListAir ').then(res => {
        if (res.data.code === 200) {
          this.KYWarehouseList = res.data.datas
        }
      })
    }
  },

  created() {
    (() => {
      // 不能用json 方法会被删除  解决:把方法放出去后面再挂载
      let innerData = JSON.parse(JSON.stringify(this.fclRequestParams)); //利用闭包缓存
      let clearMethods = () => {
        //把方法放出去后面再挂载 不然执行一次，下一次赋值中的对象没有此方法了
        // console.log(innerData); //这里不json的话 会把地址复制给他，这样就没意义了
        this.fclRequestParams = JSON.parse(JSON.stringify(innerData));
        this.fclRequestParams.clearMethods = clearMethods;
      };
      this.fclRequestParams.clearMethods = clearMethods;
    })();
  },
  mounted() {
    var that = this;
    // 页面初始缓存物流产品/电商
    let saveData = JSON.stringify(
      {
        // 0:物流产品，1：查轨迹
        fatType: '0',
        //  产品类型：3：电商，2：国际空运，0：海运散货
        sonType: '3'
      }
    )
    localStorage.setItem("productType", saveData)
    Utils.$on("demo", function (num) {

      that.showType(num);
    });
    window.addEventListener("scroll", this.handleScroll, true);
    this.getShipCompanies(); //get船公司
    this.getCangku();
    this.getFBAfromCk();
    this.getFBAtoCk();
    this.getProvinces();
    this.getWarehouse();
    this.getPeopletable();
    // 获取省市区列表
    this.getPopList();
    this.getKYWarehouse()
    this.getLCLWarehouse()
    this.avtive = this.$route.params.avtive || '0'
  },
};
</script>
<style lang="scss" scoped>
/* jack css start  */
/* 整柜 */
.MyscrollbarS {
  overflow: auto;
  height: 200px;
  padding-right: 10px;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    //里面的中间条
    background: #409eff;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  &::-webkit-scrollbar-track {
    //包裹中间条的地方
    border-radius: 10px;
    width: 3px;
    background-color: #fffdfd;
  }
}
.priceCard {
  &:hover {
    // box-shadow:0px ​39px 43px -22px rgba(212, 212, 201, 1);
    box-shadow: 1px 3px 14px 7px rgba(212, 212, 201, 0.5);
  }
  /* height: 99px; */
  background: #ffffff;
  box-shadow: 0px 0px 39px 4px rgba(208, 208, 208, 0.32);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  font-size: 17px;
  .timeArea {
    display: flex;
    height: 45px;
    text-align: center;
    flex-direction: column;
    font-size: 12px;
    margin-top: 2px;
    align-items: center;
    justify-content: center;
    span:first-child {
      border-bottom: solid 2px #eee;
      padding: 0px 30px 3px;
      margin-bottom: 3px;
      font-weight: 600;
    }
    span:nth-child(2) {
      padding: 0px 10px 3px;
    }
  }

  .cardBody {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .fontStyle {
      font-weight: 600;
    }
    // button
    > :last-child {
      //> 只穿透一层
      width: 90px;
      height: 36px;
      font-size: 14px;
      // line-height: 65px;
    }
  }
}
.FBAtable {
  border-collapse: collapse;
  margin: 0 auto;
  text-align: center;
  width: 100%;
}
.FBAtable td,
.FBAtable th {
  border: 1px solid #cad9ea;
  color: #666;
  height: 30px;
}
.FBAtable th {
  background-color: #cce8eb;
  width: 100px;
}
.aside {
  width: 259px;
  padding: 20px;
  margin-right: 20px;
  /* height: 712px; */
  background: #ffffff;
  box-shadow: 0px 0px 39px 4px rgba(208, 208, 208, 0.32);
  border-radius: 10px;
}
/* 弹窗遮罩层 */
.dialogCover {
  width: 100%;
  height: 100%;
  background-color: rgba(88, 85, 85, 0.37);
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
}
/* 弹窗 */
.myDialog {
  min-height: 350px;
  width: 50%;
  height: 50%;
  min-height: 400px;
  width: 50%;
  height: 50%;
  background-color: #fff;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
  border-radius: 20px;
  padding: 20px;

  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
}
/* 进一步查价 */
.redBtn {
  width: 159px;
  margin-top: 30px;
  line-height: 53px;
  height: 53px;
  text-align: center;
  background: linear-gradient(-56deg, #ff3b2c 0%, #ff6a6a 100%);
  border-radius: 10px;
  color: #ffffff;
  cursor: pointer;
}
/* jack css end  */
.headerTop {
  /* 初始样式 */
  transition: 0.3s;
  margin-top: 0%;
  /* transform:translate(0,300px); */
}
.showTop {
  /* 初始样式 */
  transition: 0.3s;
  // margin-top: 10%;
  margin-top: calc(8% - 38px);
  /* transform:translate(0,300px); */
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.moText {
  margin-top: 17px;
  width: 73px;
  height: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  text-decoration: underline;
  color: #5ab53c;
}
.hindDown {
  display: none;
}
.showDown {
  transition: 0.3s;
  transform: translate(0, -76px);
}
.jiantou {
  width: 120px;
  height: 6px;
  background: url("../../assets/jiantou.png") no-repeat;
}
.wrap_s {
  float: left;
}
.vipIcon {
  background: url("../../assets/vip.png") no-repeat;
  background-size: 100% 100%;
  padding: 4px 5px 2px 7px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
}
.PSicon {
  background: url("../../assets/psicon.png") no-repeat;
  background-size: 100% 100%;
  width: 18px;
  height: 15px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 10px;
}
.Thicon {
  background: url("../../assets/thicon.png") no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 10px;
}
.Djicon {
  background: url("../../assets/djicon.png") no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 10px;
}
.OrderDetails {
  box-sizing: border-box;
  border-radius: 15px;
  overflow: hidden;
}
/* 轨迹折叠头：最新轨迹内容很长换行时，不继承48px行高、不被固定高度盖住 */
.track-collapse >>> .el-collapse-item__header {
  height: auto;
  min-height: 48px;
  padding: 8px 0;
  box-sizing: border-box;
  line-height: 1.5;
}
.OrderDetails .occurrence {
  position: absolute;
  left: -36px;
  top: 3px;
  margin-top: 0;
  color: #999999;
  font-size: 11px;
  text-align: right;
  width: 150px;
}
.Mostyle >>> input {
  border: none;
}
.OldwidthType {
  width: 100%;
}
.NewwidthType {
  width: 50%;
}
.navItem {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  //color: block;
  float: left;
  margin-right: 52px;
  position: relative;
  cursor: pointer;
}

.navson {
  width: 54px;
  height: 2px;
  background: #ffffff;
  border-radius: 1px;
  position: absolute;
  left: 0;
  bottom: -10px;
}
.activesonty {
  color: #5ab53c;
}
.activesonty2 {
  width: 100%;
  background: #5ab53c;
}
.Gotobtn {
  cursor: pointer;
  margin-top: 16px;
  width: 171px;
  height: 50px;
  background: #5ab53c;
  border-radius: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
.card_wrap {
  width: 1098px;
  background: #ffffff;
  box-shadow: 0px 0px 39px 5px rgba(208, 208, 208, 0.32);
  border-radius: 10px;
  float: left;
  padding: 35px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.Bom_style {
  width: 95px;
  height: 30px;
  background: #efecff;
  border-radius: 15px;
  float: left;
  margin-right: 30px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  color: #5ab53c;
  font-size: 14px;
}
.count_Bom {
  width: 100%;
  float: left;
  margin-top: 30px;
}
.fontTyle {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.showbgColor {
  height: 100%;
  background: #fbfbfb;
}
.show_count {
  transform: translate(0, -20px);
  margin: 0 auto;
  padding: 30px;
  box-sizing: border-box;
}
.huowuData {
  width: 100%;
  /* height: 100%; */
  display: flex;
  display: -webkit-flex;
  align-items: center;
  /* justify-content: center; */
  flex-direction: column;
  padding: 0 0 100px 0;
}
.navlist {
  width: 100%;
}

.select {
  position: relative;
}
.selectIcon {
  position: absolute;
  left: 18px;
  top: 10px;
  z-index: 999;
  font-size: 18px;
  color: #ccc;
}
.select2 {
  position: relative;
}
.select2 >>> .el-input__inner {
  padding-left: 50px !important;
}
.selectIcon2 {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 999;
  font-size: 18px;
  color: #ccc;
}
.count_text >>> .el-input__inner {
  padding: 0 30px !important;
  border: 2px solid #dcdfe6 !important;
  border-radius: 10px !important;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.count_text {
  padding: 33px 26px 32px 22px;
  box-sizing: border-box;
  width: 1098px;
  background: #ffffff;
  border-radius: 0px 10px 10px 10px;
  float: left;
}
.nav_count {
  width: 100%;
  /* height: 80px; */
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.oldnavcalss {
  cursor: pointer;
  width: 150px;
  height: 40px;
  padding-top: 8px;
  box-sizing: border-box;
  background: black;
  background-color: #5ab53c;
  border-radius: 10px 10px 0px 0px;
  float: left;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.navStyle {
  color: #5ab53c;
  opacity: 1;
  background: #ffffff;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #5ab53c;
}

.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.phone:hover {
  transform: translate(-200px, 0px);
  transition: transform 300ms;
  box-shadow: 0px 0px 39px 5px rgba(208, 208, 208, 0.32);
}
.trackTable {
  width: 1081px;
  border-radius: 15px;
}
/deep/.el-table .cell {
  word-break: break-word;
}

.clickPointer {
  position: absolute;
  left: 0px;
  bottom: 30px;
  // bottom: 40px;
  width: 100%;
  // height: 120px;
  height: 160px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 50px;
  user-select: none;
}
.click_pointer_con {
  position: relative;
  width: 720px;
  height: 100%;
  cursor: pointer;
}
.fyb_zbx_img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.dragon_img {
  display: inline-block;
  position: absolute;
  left: 20px;
  bottom: 0px;
  width: 100px;
  height: 110px;
  object-fit: contain;
}
.click_pointer {
  position: absolute;
  top: 83px;
  right: -13px;
  width: 50px;
  height: 60px;
  object-fit: contain;
  transform: rotate(-25deg);
}
.click_pointer_up {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 70px;
  padding-left: 120px;
}
.click_pointer_up .bottom_icon {
  position: absolute;
  right: 20px;
  width: 100px;
  height: 40px;
  object-fit: contain;
}
.click_up_content {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 14px;
  font-size: 25px;
  font-weight: bold;
  letter-spacing: 2px;
  color: rgb(236, 253, 244);
}
.click_up_content span {
  font-size: 34px;
}
.click_pointer_down {
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  gap: 10px;
  width: 100%;
  height: 50px;
  border-radius: 12px;
  background-color: #fff;
  padding-left: 120px;
  color: #606266;
  letter-spacing: 1px;
}
.click_down_left {
  font-size: 26px;
  font-style: italic;
}
.click_down_right {
  font-size: 24px;
  font-style: italic;
  padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/placeIndex.vue